// Code generated by tygo. DO NOT EDIT.
/* eslint-disable */
/* prettier-ignore */
import type * as api from "./aichatapi.gen"
import type * as core from "../../../core/wire/core.gen"

//////////
// source: activity.go

/**
 * ActivityQuestion: Claude asks — a question, a plan or a request to change code opened. The
 * asker at once, the assignees once it stayed open a while.
 */
export const ActivityQuestion = "aichat.question";
/**
 * ActivityAnswered: somebody else — another owner or the watchdog — answered the reader's card.
 */
export const ActivityAnswered = "aichat.answered";
/**
 * ActivityFinished: the reader's request finished while they were not looking at the chat.
 */
export const ActivityFinished = "aichat.finished";
/**
 * ActivityStopped: another owner stopped the reader's request.
 */
export const ActivityStopped = "aichat.stopped";
/**
 * ActivityPaused: the chat paused, or the request failed, and waits for a person.
 */
export const ActivityPaused = "aichat.paused";
/**
 * ActivityLogin: one of the reader's Claude logins expires soon, expired or was refused by Claude
 * (to its owner).
 */
export const ActivityLogin = "aichat.login";
/**
 * ActivityReady: a revision is ready to publish.
 */
export const ActivityReady = "aichat.ready";
/**
 * ActivityAttention: checks failed on a revision, or published code changed in its places.
 */
export const ActivityAttention = "aichat.attention";
/**
 * ActivityReviewRequested: an owner asks a developer to look at a revision.
 */
export const ActivityReviewRequested = "aichat.review_requested";
/**
 * ActivityPublished: a revision was published.
 */
export const ActivityPublished = "aichat.published";
/**
 * ActivityPartlyPublished: publishing stopped after some repositories.
 */
export const ActivityPartlyPublished = "aichat.partly_published";
/**
 * ActivityAssigned: another owner assigned the reader to a chat.
 */
export const ActivityAssigned = "aichat.assigned";
/**
 * ActivityAccess: a visitor asks to open a private preview (R1b).
 */
export const ActivityAccess = "aichat.access";
/**
 * ActivityMention: an owner mentioned the reader in a message.
 */
export const ActivityMention = "aichat.mention";
/**
 * ActivityStale: a chat with unpublished work was quiet for a long time.
 */
export const ActivityStale = "aichat.stale";
/**
 * ActivityData is the payload of every row of the module. ChatId and Key name the chat (both empty
 * on the login row, which is about no chat); the rest is filled per kind:
 *   - Reason: a pause's word (Pause*, or "failed" for a request that failed); an answer's choice
 *     (allow, keep, start, …) or, for the watchdog's, its how (auto, parked); an attention row's
 *     Detail* word.
 *   - State: the login row's word — which of LoginNotices it tells. The row is per login and notice,
 *     so two logins' reminders stay two rows.
 *   - Login and Label: the login row's login, by its id and the owner's label for it.
 *   - N: the revision a row is about.
 *   - CardKind: which card a question or an answer row is about.
 *   - Mode: the chat's mode where the sentence depends on it ("answered" or "finished").
 *   - Parts: the codebase parts a publish landed.
 *   - ExpiresAt: when the login's token expires (the login row's reminders and expiry).
 *   - NotOwner: the row reached somebody who does not own the chat — a developer, an admin, the
 *     group told of every publish — so it names the key and leads nowhere.
 *   - Count: how many rows the feed folded into this one (written by core's feed).
 */
export interface ActivityData {
	chatId?: number /* int64 */;
	key?: string;
	reason?: string;
	n?: number /* int64 */;
	cardKind?: api.CardType;
	mode?: api.ChatMode;
	parts?: string[];
	state?: string;
	login?: string;
	label?: string;
	expiresAt?: number /* int64 */;
	notOwner?: boolean;
	count?: number /* int */;
}
/**
 * The login row's notices (S17 §2), each told once per login: 14 days and 1 day before the token's
 * expiry, the expiry itself, and Claude's refusal. The first three are also the stages a login's
 * record keeps as told (aichat_login.notified), so a restart sends none twice.
 */
export const LoginNoticeD14 = "d14";
/**
 * The login row's notices (S17 §2), each told once per login: 14 days and 1 day before the token's
 * expiry, the expiry itself, and Claude's refusal. The first three are also the stages a login's
 * record keeps as told (aichat_login.notified), so a restart sends none twice.
 */
export const LoginNoticeD1 = "d1";
/**
 * The login row's notices (S17 §2), each told once per login: 14 days and 1 day before the token's
 * expiry, the expiry itself, and Claude's refusal. The first three are also the stages a login's
 * record keeps as told (aichat_login.notified), so a restart sends none twice.
 */
export const LoginNoticeExpired = "expired";
/**
 * The login row's notices (S17 §2), each told once per login: 14 days and 1 day before the token's
 * expiry, the expiry itself, and Claude's refusal. The first three are also the stages a login's
 * record keeps as told (aichat_login.notified), so a restart sends none twice.
 */
export const LoginNoticeRefused = "refused";
/**
 * ReasonFailed is a paused row's Reason for a request that failed without a pause.
 */
export const ReasonFailed = "failed";

//////////
// source: admin.go

/**
 * AdminChatRow is one chat of GET /api/admin/aichat/chats. The row carries its owner groups and its
 * creator already; AdminOwns says whether the reading admin is an owner too, so the page offers the
 * chat itself only to an owner and the audited rescue acts to anyone else. Env is where the chat's
 * environment is, which only admins see.
 */
export interface AdminChatRow {
	row: ChatRow;
	adminOwns: boolean;
	env: AdminEnv;
}
/**
 * AdminEnv is one chat's environment as the admin's list shows it: its line, its container's state
 * on the worker and the disk it uses there, and what teamBase preserves of it on the server — the
 * newest session pack and, while the chat is deactivated, its keep folder.
 */
export interface AdminEnv extends EnvLine {
	/**
	 * LineWhy is why a container waits in the machine's start line (InLine's machine words): a full
	 * running budget, the network rules not loaded, or a disk below its floor; "" when it waits in none.
	 */
	lineWhy?: string;
	container?: string;
	diskUsed?: number /* int64 */;
	packBytes?: number /* int64 */;
	keepBytes?: number /* int64 */;
}
/**
 * AdminChatList is a page of GET /api/admin/aichat/chats. AgentsOpen is answered with the filter
 * AdminFilterAgentsClosed alone: how many chats other AI chats can read, the default — every chat the
 * page does not list.
 */
export interface AdminChatList {
	chats: AdminChatRow[];
	nextCursor?: string;
	agentsOpen?: number /* int */;
}
/**
 * MachineView is GET /api/admin/aichat/machine (R1b): the worker machine as its two health pictures
 * last described it, the state word every member sees, and what teamBase's own record says of the
 * chats there — the record holds the deactivated chats and what the server keeps of them, which no
 * picture of the machine counts, and it keeps saying so while the machine is silent. A picture is absent until the
 * machine has sent one since teamBase started; Worker and ReportAt then name who sent the newest and
 * when it arrived.
 */
export interface MachineView {
	line: MachineLine;
	chat?: api.ChatHealth;
	auth?: api.AuthHealthPicture;
	worker?: string;
	reportAt?: number /* int64 */;
	chats: MachineChats;
	/**
	 * Previews count the previews that may run, by the state the machine last reported for each
	 * (aichatapi.PreviewStates).
	 */
	previews: { [key: string]: number /* int */};
	/**
	 * DeactivateAfterMs and DeactivatePoolAbove are the sweep's rule: a chat unused for that long may
	 * be deactivated while the worker's pool is used above that share (deactivate_after,
	 * deactivate_pool_above). The page shows them, never sets them.
	 */
	deactivateAfterMs: number /* int64 */;
	deactivatePoolAbove: number /* float64 */;
	/**
	 * EnvTroubles are the deactivations the worker refused in the last day, those unfinished for an
	 * hour either way, and the broken containers, newest first, at most MachineTroublesMax.
	 */
	envTroubles: EnvTrouble[];
	/**
	 * TurnsRunning is how many turns run now across every chat; the picture's capacity holds the live
	 * CLIs the machine keeps (liveCliSoftMax), which the page draws them against.
	 */
	turnsRunning: number /* int */;
	/**
	 * Queue is the open chats whose request waits, oldest first, at most MachineQueueMax: the chat, its
	 * mode, whose request it is, since when it waits and what for (MachineWaits).
	 */
	queue: MachineQueueRow[];
	/**
	 * Members are the people with a turn running now and the cap of turns one person runs at once.
	 */
	members: MachineMember[];
	perPerson: number /* int */;
	/**
	 * Doctor is every aichat.* doctor row as `teambase doctor` answers it now.
	 */
	doctor: MachineDoctorRow[];
}
/**
 * MachineQueueMax bounds the queue the Machine view lists.
 */
export const MachineQueueMax = 50;
/**
 * MachineQueueRow is one chat whose request waits.
 */
export interface MachineQueueRow {
	chatId: number /* int64 */;
	key: string;
	mode: string;
	askerId?: number /* int64 */;
	since: number /* int64 */;
	/**
	 * WaitsFor is what the request waits for (MachineWaits): the machine's room, its asker's other
	 * turns, the network rules, the machine's disk, its sender's Claude login, a switch, a person's hold, a
	 * pause, or nothing but its turn ("next").
	 */
	waitsFor: string;
}
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsNext = "next";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsMachine = "machine";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsAsker = "asker";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsNetwork = "network";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsDisk = "disk";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsLogin = "login";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsSwitch = "switch";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsHold = "hold";
/**
 * What a waiting request waits for, as the Machine view's queue names it; the four waits of a head
 * in line are InLine's own words (InLineMachine, InLineAsker, InLineNetwork, InLineDisk), spelt out
 * here because the browser's generated constants are declared in this file's order.
 */
export const MachineWaitsPause = "pause";
/**
 * MachineMember is one person with turns running.
 */
export interface MachineMember {
	userId: number /* int64 */;
	running: number /* int */;
}
/**
 * MachineDoctorRow is one aichat.* doctor row: its name, ok, warn or fail (core's health states), and
 * what it says when it is not ok.
 */
export interface MachineDoctorRow {
	name: string;
	state: string;
	message?: string;
	/**
	 * At is when the row's finding began, where it names one moment (a cut-off in force): the page
	 * formats it beside the message, which leaves it out.
	 */
	at?: number /* int64 */;
}
/**
 * The states of a MachineDoctorRow.
 */
export const DoctorOK = "ok";
/**
 * The states of a MachineDoctorRow.
 */
export const DoctorWarn = "warn";
/**
 * The states of a MachineDoctorRow.
 */
export const DoctorFail = "fail";
/**
 * MachineChats is teamBase's record of where the chats' environments are: ByEnv counts every chat by
 * its environment (EnvStates); Preserved, PreservedBytes and PreservedMaxBytes are what the server
 * keeps of deactivated chats — how many, their bytes — and the budget it keeps them under
 * (preserved_max_bytes).
 */
export interface MachineChats {
	byEnv: { [key: string]: number /* int */};
	preserved: number /* int */;
	preservedBytes: number /* int64 */;
	preservedMaxBytes: number /* int64 */;
}
/**
 * MachineTroublesMax bounds the environments in trouble the Machine view lists.
 */
export const MachineTroublesMax = 20;
/**
 * EnvTrouble is one chat whose environment needs an admin's eye: Kind (EnvTroubleKinds) says how,
 * Reason is the worker's code for a refusal, At when it happened (or since when it has been
 * unfinished).
 */
export interface EnvTrouble {
	key: string;
	kind: string;
	reason?: string;
	at: number /* int64 */;
}
/**
 * The kinds of an EnvTrouble: a deactivation the worker refused (the container stayed), one
 * unfinished for an hour, a reactivation unfinished for an hour, a container the worker reports
 * broken, and a keep pack a reactivation found gone from the blob store (At: since when), which a
 * restore of the blobs and a reset of the environment bring back.
 */
export const EnvTroubleRefused = "refused";
/**
 * The kinds of an EnvTrouble: a deactivation the worker refused (the container stayed), one
 * unfinished for an hour, a reactivation unfinished for an hour, a container the worker reports
 * broken, and a keep pack a reactivation found gone from the blob store (At: since when), which a
 * restore of the blobs and a reset of the environment bring back.
 */
export const EnvTroubleStuckOut = "stuck_deactivating";
/**
 * The kinds of an EnvTrouble: a deactivation the worker refused (the container stayed), one
 * unfinished for an hour, a reactivation unfinished for an hour, a container the worker reports
 * broken, and a keep pack a reactivation found gone from the blob store (At: since when), which a
 * restore of the blobs and a reset of the environment bring back.
 */
export const EnvTroubleStuckBack = "stuck_reactivating";
/**
 * The kinds of an EnvTrouble: a deactivation the worker refused (the container stayed), one
 * unfinished for an hour, a reactivation unfinished for an hour, a container the worker reports
 * broken, and a keep pack a reactivation found gone from the blob store (At: since when), which a
 * restore of the blobs and a reset of the environment bring back.
 */
export const EnvTroubleBroken = "broken";
/**
 * The kinds of an EnvTrouble: a deactivation the worker refused (the container stayed), one
 * unfinished for an hour, a reactivation unfinished for an hour, a container the worker reports
 * broken, and a keep pack a reactivation found gone from the blob store (At: since when), which a
 * restore of the blobs and a reset of the environment bring back.
 */
export const EnvTroubleKeepMissing = "keep_missing";
/**
 * PurgeRequest is POST /api/admin/aichat/items/{itemId}/purge: why, in the admin's words, which are
 * checked and never kept. It travels in the body, never in a URL an access log keeps.
 */
export interface PurgeRequest {
	reason: string;
}

//////////
// source: bootstrap.go

/**
 * AichatBootstrap is the module's entry in rt.bootstrap (S03 §6, S13 §1): everything the rail, the
 * start page's lists and the unread dots need before a single request — the reader's open chats and
 * those closed in the last fourteen days (at most MaxBootstrapChats rows; More says there are more to
 * page through GET /api/aichat/chats), their titles, the reader's read state per chat, the worker
 * machine's state word and the new-chat form's options (with the reader's own Claude logins).
 * Only chats the reader owns are in it, so an "Only me" chat of somebody else is in no one else's
 * bootstrap.
 */
export interface AichatBootstrap {
	chats: ChatRow[];
	titles: { [key: number /* int64 */]: string};
	more: boolean;
	readers: ReaderState[];
	machine: MachineLine;
	setup: SetupView;
}
/**
 * MaxBootstrapChats bounds AichatBootstrap.Chats.
 */
export const MaxBootstrapChats = 300;
/**
 * BootstrapClosedDays is how long a closed chat stays in the bootstrap after it closed.
 */
export const BootstrapClosedDays = 14;

//////////
// source: call.go

/**
 * CallView is one call as one reader reads it.
 */
export interface CallView {
	/**
	 * Words is the row's key: aichat.call.<row kind> (read, searchAll, list, work, export, guide),
	 * aichat.call.suggested for a change that arrived as a suggestion, aichat.call.refused for a refusal.
	 */
	words: string;
	/**
	 * Target is what the call was about; empty when the call named nothing.
	 */
	target: CallTargetView;
	/**
	 * Reason is a refusal's reason, aichat.call.reason.<…>.
	 */
	reason?: string;
	/**
	 * Cause is what stands in the way now, aichat.call.cause.<…>: only for a reader who may open the
	 * target, and only while it still stands.
	 */
	cause?: string;
}
/**
 * CallTargetView is a call's target as one reader may see it: its name, with where it opens when the
 * reader may open it, or a key in place of a name — aichat.call.target.<kind> for a call about a kind
 * as a whole (or a named AI chat, "the AI chat {title}"), aichat.call.restricted.<kind> for a thing the
 * reader may not see.
 */
export interface CallTargetView {
	words?: string;
	label?: string;
	href?: string;
}

//////////
// source: chat.go

/**
 * ChatRow is one chat as every list, the band and the event draw it: its settings as ids and words,
 * its derived state, and the counters a reader compares with what it holds. Of two rows for one chat
 * the higher Rev is the newer; ItemRev tells a page with the chat open to fetch what it has not seen.
 */
export interface ChatRow {
	chatId: number /* int64 */;
	key: string;
	rev: number /* int64 */;
	titleRev: number /* int64 */;
	mode: api.ChatMode;
	/**
	 * ModeSwitch is a switch pressed and not yet applied on the worker machine: it waits for the next
	 * quiet point, then for dev's answer.
	 */
	modeSwitch?: ModeSwitch;
	/**
	 * Driver is which kind of Claude Code process holds the chat's session now, as the worker last
	 * pictured it: the chat view's (gui, also while none runs) or the terminal's (cli).
	 */
	driver: api.Driver;
	/**
	 * DriverSwitch is the newest press of Start Claude Code here or of its way back, while it waits
	 * for the session's quiet point, or for a while after the worker refused or lost it.
	 */
	driverSwitch?: DriverSwitch;
	/**
	 * TurnDriver is where the open turn runs; "" while none is open.
	 */
	turnDriver?: api.Driver;
	/**
	 * Terminal is the chat's terminal while one runs, and for a while after it ended; nil otherwise.
	 */
	terminal?: TerminalLine;
	/**
	 * TerminalHold is set while a message of the chat view waits because the terminal is in use.
	 */
	terminalHold?: TerminalHold;
	life: string;
	run: string;
	runDetail?: DetailLine;
	change: string;
	revisionN?: number /* int64 */;
	headline: string;
	headlineDetail?: DetailLine;
	tone: string;
	turnId?: number /* int64 */;
	askerId?: number /* int64 */;
	session: SessionLine;
	queue: QueueState;
	base: BaseLine;
	size?: SizeLine;
	accessOpen?: number /* int */;
	/**
	 * Env is where the chat's environment stands — its container on the dev worker — in the word
	 * people read (EnvWords) and, while it is away, why.
	 */
	env: EnvLine;
	/**
	 * Previews are the chat's previews, defaults first in their parts' order and then the others by
	 * name: a preview the chat may not run now is off, with its cause.
	 */
	previews: PreviewLine[];
	ownerGroupIds: number /* int64 */[];
	assigneeIds: number /* int64 */[];
	createdBy: number /* int64 */;
	createdAt: number /* int64 */;
	lastActivityAt: number /* int64 */;
	itemRev: number /* int64 */;
	lastSeq: number /* int64 */;
	/**
	 * CountSeq is the seq of the newest item that moves the unread dot.
	 */
	countSeq: number /* int64 */;
	waiting: WaitRow[];
	/**
	 * MCPSince is when the members' MCP servers the chat's Claude Code was last started with changed,
	 * cleared with its container included (0: never): a page that shows them reads ChatView.MCPServers
	 * again when it moves. The names never ride the row, a durable event.
	 */
	mcpSince?: number /* int64 */;
	/**
	 * NativeSince is when the chat's own Claude login — a sign-in made with Claude Code's /login in its
	 * terminal — was signed in, and NativeBy who signed it in (0: nobody typed it); both 0 while the chat
	 * holds none. Every request of the chat runs on that login while it is there. A page that shows the
	 * account reads ChatView.Native again when NativeSince moves: the account never rides the row.
	 */
	nativeSince?: number /* int64 */;
	nativeBy?: number /* int64 */;
	/**
	 * AgentsAvailable is the owners' switch Other AI chats can read this chat: while it is on, Claude in
	 * another AI chat may read this one's record and revisions, when every owner of that chat owns this
	 * one too. On for every chat until an owner turns it off. AgentsSetBy and AgentsSetAt say who last
	 * moved it and when; both 0 while it stands at its default.
	 */
	agentsAvailable: boolean;
	agentsSetBy?: number /* int64 */;
	agentsSetAt?: number /* int64 */;
	/**
	 * AgentCeiling is how far Claude in this chat may go in a drive — "write", "suggest", "read" or
	 * "none" (core.AgentLevel's words) —, whatever a folder or document allows: the lower of the two
	 * wins. "write", no cap, for every chat until an owner lowers it. CeilingSetBy and CeilingSetAt say
	 * who last set it and when; both 0 while nobody has.
	 */
	agentCeiling: string;
	ceilingSetBy?: number /* int64 */;
	ceilingSetAt?: number /* int64 */;
}
/**
 * EnvLine is a chat's environment as every list and the band read it. State is the people's word
 * (EnvWords), derived on teamBase from the chat's stored state and the worker's newest picture; ""
 * while the chat has no environment yet. Since is when that state began. While the environment is
 * deactivating, deactivated or reactivating, Cause says why it went (aichatapi.EnvCauses) and At when
 * the deactivation was decided. Failure is the reason the last reactivation failed, and GaveUp says
 * its retries are spent: the page then offers Try again. Extra is the additional container's state
 * (aichatapi.ExtraStates) while the environment is present and the worker has pictured one: a move of
 * it changes the row, so an open Settings reads the chat's view again.
 */
export interface EnvLine {
	state: string;
	since?: number /* int64 */;
	cause?: string;
	at?: number /* int64 */;
	failure?: string;
	gaveUp?: boolean;
	extra?: string;
}
/**
 * ModeSwitch is a pending switch: to which mode, since when, pressed by whom (0 when the switch is
 * the answer to Claude's request applied by the system).
 */
export interface ModeSwitch {
	to: api.ChatMode;
	since: number /* int64 */;
	by: number /* int64 */;
}
/**
 * DriverSwitch is the newest driver press of a chat: to which driver, whether it restarts a running
 * terminal, who pressed and when. State is DriverSwitchPending while the command waits for the
 * session's quiet point and the worker's answer, and DriverSwitchFailed for aichatapi's
 * DriverFailShowFor after the worker refused, failed or lost it, with Reason its word (the command's
 * reason, or DriverSwitchLost); a press that went through leaves no switch.
 */
export interface DriverSwitch {
	to: api.Driver;
	restart?: boolean;
	by: number /* int64 */;
	at: number /* int64 */;
	state: string;
	reason?: string;
}
/**
 * The states of DriverSwitch, and the reason of a press its session took with it.
 */
export const DriverSwitchPending = "pending";
/**
 * The states of DriverSwitch, and the reason of a press its session took with it.
 */
export const DriverSwitchFailed = "failed";
/**
 * The states of DriverSwitch, and the reason of a press its session took with it.
 */
export const DriverSwitchLost = "lost";
/**
 * TerminalLine is the chat's terminal as every page reads it, from the worker's newest picture: its
 * state (aichatapi.TerminalStates) since Since, the restart it owes (aichatapi.RestartDueReasons),
 * whether Claude Code waits for a person there (aichatapi.HostWaits), and its code — while broken
 * why, while off why it ended (aichatapi.TerminalEnds), which the line keeps for TerminalEndShowFor —
 * and since when something that ends it waits for a line being typed there (HoldSince, 0: nothing).
 * It holds no size and no viewer: the row is a durable event, and a size moves with every resize.
 */
export interface TerminalLine {
	state: string;
	since?: number /* int64 */;
	restartDue?: string;
	waits?: string;
	code?: string;
	holdSince?: number /* int64 */;
}
/**
 * TerminalHold is a message of the chat view waiting for the terminal (the hand-over to the chat
 * view): since when, why (aichatapi.HoldReasons) and who typed last there (0: nobody yet).
 */
export interface TerminalHold {
	since: number /* int64 */;
	reason: string;
	by?: number /* int64 */;
}
/**
 * DetailLine names which reason of a headline or a run holds, with the numbers its sentence needs.
 * Word is a Detail* or a Pause* word; the other fields are read per word — a revision's n, a push's i
 * of k, a workflow's phase i of k with count agents, a stall's count minutes, a hold's count prompts
 * held by userId, a limit's window, scope and untilAt, the login's state, a switch's to, the place in
 * line i and why, an environment's step, a pause's reason (the machine's refusal that set it, when the
 * server saw it). A wait's at is when it began: the environment's state, or the request's sending
 * where the wait has no clock of its own.
 */
export interface DetailLine {
	word: string;
	n?: number /* int64 */;
	i?: number /* int */;
	k?: number /* int */;
	count?: number /* int */;
	userId?: number /* int64 */;
	at?: number /* int64 */;
	untilAt?: number /* int64 */;
	/**
	 * Auto is a limit pause's promise: Claude continues by itself a minute after UntilAt. Without it
	 * the limit waits for someone to press Continue once it has reset. On a login pause it says the
	 * pause was met by a request Claude began by itself, not by a person's request that stopped.
	 */
	auto?: boolean;
	window?: string;
	scope?: string;
	state?: string;
	to?: api.ChatMode;
	/**
	 * Parts are the parts a published revision changed, in configuration order: whose sites it
	 * reaches with the next deploy.
	 */
	parts?: string[];
}
/**
 * SessionLine is what Claude runs as in this chat: the model, the effort (” is the model's own) and
 * the CLI's permission mode of the next turn.
 */
export interface SessionLine {
	model: string;
	effort: string;
	permissionMode: api.PermissionMode;
}
/**
 * QueueState is the chat's queue as a composer and a list draw it.
 */
export interface QueueState {
	queued: number /* int */;
	held: boolean;
	heldBy?: number /* int64 */;
	nextAuthorId?: number /* int64 */;
}
/**
 * BaseLine is where the chat's code stands against main: a read-only chat's pins, a modifying
 * chat's latest revision's bases. PinnedAt is when a read-only chat's pins were set; Kept counts the
 * unpublished revisions a read-only chat keeps from its modifying time.
 */
export interface BaseLine {
	state: string;
	repos: BaseRepo[];
	pinnedAt?: number /* int64 */;
	kept?: KeptLine;
}
/**
 * The words of BaseLine.State.
 */
export const BaseCurrent = "current";
/**
 * The words of BaseLine.State.
 */
export const BaseBehind = "behind";
/**
 * The words of BaseLine.State.
 */
export const BaseUpdating = "updating";
/**
 * The words of BaseLine.State.
 */
export const BaseConflict = "conflict";
/**
 * BaseRepo is one repository's distance from its main by the last fetch.
 */
export interface BaseRepo {
	repo: string;
	behind: number /* int */;
}
/**
 * KeptLine counts a read-only chat's unpublished revisions.
 */
export interface KeptLine {
	n: number /* int */;
}
/**
 * SizeLine is the size of the latest revision's change: files touched and lines added and removed.
 */
export interface SizeLine {
	files: number /* int */;
	added: number /* int */;
	removed: number /* int */;
}
/**
 * WaitRow is one reason the chat waits for some of its people (S01 §4.5), in one tone. N is the
 * reason's number where it has one: the revision a developer was asked about, the open access
 * requests, and for a question, plan or modify wait the card's seq.
 */
export interface WaitRow {
	reason: string;
	userIds: number /* int64 */[];
	tone: string;
	n?: number /* int64 */;
	since?: number /* int64 */;
}
/**
 * ChatView is one chat as its page opens it: the row, the title, what the caller may do in it, and
 * the caller's own read state. EventId pairs the answer with the realtime stream (protocol.md §3.2).
 */
export interface ChatView {
	row: ChatRow;
	title: string;
	titleSource: string;
	/**
	 * SoloOwnerId is set while exactly one person owns the chat: an "Only me" chat, or any owner set
	 * that resolves to one person. The page then says it is private.
	 */
	soloOwnerId?: number /* int64 */;
	session: SessionView;
	repos: RepoLine[];
	viewer: ViewerCaps;
	reader: ReaderState;
	eventId: number /* int64 */;
	/**
	 * Env is the chat's container as Settings → Environment shows it, from the worker's newest
	 * pictures and the chat's record.
	 */
	env: EnvFacts;
	/**
	 * RunsOn is what the chat runs on: its open turn's credential, else its last turn's; absent before
	 * the first turn.
	 */
	runsOn?: RunsOn;
	/**
	 * MyLogin is the caller's active Claude login: what their next message runs on while the chat holds
	 * no login of its own; absent while they hold none, and then they cannot send in such a chat.
	 */
	myLogin?: LoginLine;
	/**
	 * Native is the chat's own Claude login while it holds one: every request of the chat, anyone's,
	 * runs on it until it is signed out.
	 */
	native?: NativeLine;
	/**
	 * MCPServers are the members' MCP servers the chat's Claude Code was last started with, by name and
	 * sorted (teamBase's own is never among them); absent when it named none, before its first start
	 * and once its container is gone.
	 */
	mcpServers?: string[];
}
/**
 * EnvFacts are the facts of a chat's container, from the newest host and health pictures teamBase
 * holds in memory and the chat's own record; every field is zero while there is no picture.
 * Container is its state on the worker (aichatapi.ContainerStates) since Since; Created when it was
 * made, in epoch ms (a JavaScript number cannot hold the picture's nanoseconds). Step is the step of a
 * set-up, wake or reactivation it is at (aichatapi.EnvSteps) since StepSince, and Line its place in
 * the worker's start line (0: none) and why it waits (aichatapi.LineWhys). The disk is used of its
 * quota, and DiskFull says it ran full. Image is the image it was made from, and ImageNewer that a
 * newer one is current, which a reset would bring. Extra is the additional container's state
 * (aichatapi.ExtraStates) since ExtraSince. While the chat is deactivated, KeepBytes is its preserved
 * keep folder and KeepLeftOut the files that did not fit. WorkLeftOut names the uncommitted files the
 * newest capture could not bring into teamBase's record (over its cap, or withheld as a secret), each
 * under its repository, at most aichatapi.MaxNoticePaths, and WorkLeftOutMore counts the rest: a new
 * container — a reactivation, a reset — comes without them. Unsaved says a reset would lose work no
 * capture holds, which the reset dialog says before anybody confirms.
 */
export interface EnvFacts {
	container?: string;
	since?: number /* int64 */;
	created?: number /* int64 */;
	step?: string;
	stepSince?: number /* int64 */;
	line?: number /* int */;
	lineWhy?: string;
	diskUsed?: number /* int64 */;
	diskQuota?: number /* int64 */;
	diskFull?: boolean;
	image?: string;
	imageNewer?: boolean;
	extra: string;
	extraSince?: number /* int64 */;
	keepBytes?: number /* int64 */;
	keepLeftOut?: number /* int */;
	/**
	 * WorkLeftOut and WorkLeftOutMore are the uncommitted files the record never held, named and
	 * counted beyond the names.
	 */
	workLeftOut?: string[];
	workLeftOutMore?: number /* int */;
	unsaved?: boolean;
}
/**
 * SessionView is SessionLine, the Claude Code version the chat's last session ran, and the Claude
 * login the chat runs on ("" for the default one, and left out then).
 */
export interface SessionView {
	model: string;
	effort: string;
	permissionMode: api.PermissionMode;
	cliVersion?: string;
}
/**
 * RepoLine is one repository of the chat's copy: which part brought it, its place under the chat's
 * src/ as people and Claude know it ("" where the instance names none, and the id stands), and for a
 * read-only chat without revisions the main commit it reads. Place is what lets every line of the
 * conversation name a repository by its folder rather than by its configuration id, the way the
 * review does with RepoRev's.
 */
export interface RepoLine {
	repo: string;
	part: string;
	place: string;
	pin?: string;
}
/**
 * ViewerCaps is what the caller may do in this chat, computed with the policy so the browser never
 * re-derives a cell: a button the caller may not press is not drawn.
 */
export interface ViewerCaps {
	canPost: boolean;
	canSteer: boolean;
	canStop: boolean;
	canCommand: boolean;
	canConfirm: boolean;
	canManage: boolean;
	canSetMode: boolean;
	/**
	 * CanSetDriver is aichat.driver.set: Start Claude Code here, its way back and Restart now.
	 */
	canSetDriver: boolean;
	/**
	 * CanTerminal is aichat.terminal.write: typing into the chat's terminal; without it the terminal
	 * is read only.
	 */
	canTerminal: boolean;
	/**
	 * CanPreview is aichat.preview.set: the previews' public switches, their start, stop and restart,
	 * and the preview panel with its sign-in accounts and mail.
	 */
	canPreview: boolean;
	canRename: boolean;
	canClose: boolean;
	canReopen: boolean;
	isAssignee: boolean;
	/**
	 * IsOwner is false for an admin who reaches the chat only through the audited rescue.
	 */
	isOwner: boolean;
}
/**
 * ReaderState is one person's read state in one chat: the cursor, the dot, and their own waits.
 */
export interface ReaderState {
	chatId: number /* int64 */;
	lastReadSeq: number /* int64 */;
	version: number /* int64 */;
	unread: number /* int */;
	waiting: boolean;
	manualUnread: boolean;
	openedAt?: number /* int64 */;
}
/**
 * ChatList is a page of the home's list: the rows, their titles by chat id, and the cursor of the
 * next page.
 */
export interface ChatList {
	chats: ChatRow[];
	titles: { [key: number /* int64 */]: string};
	nextCursor?: string;
	eventId: number /* int64 */;
}
/**
 * OwnersAnswer is the owner routes' answer: the chat as it now stands, or Gone when the change ended
 * the caller's own ownership (the page asked first, and now leaves).
 */
export interface OwnersAnswer {
	chat?: ChatView;
	gone: boolean;
}
/**
 * ChatGone is the payload of `aichat.chat.gone`: a write took the receiving user's ownership away.
 */
export interface ChatGone {
	chatId: number /* int64 */;
}
/**
 * UpdateChatRequest is PATCH …/{key}: a person's title.
 * A title comes with Rev, the ChatRow.TitleRev the page holds: a title somebody else saved meanwhile
 * answers revChanged instead of being overwritten, while a turn or a queue change moving the row's own
 * rev never does.
 */
export interface UpdateChatRequest {
	title?: string;
	rev?: number /* int64 */;
}
/**
 * LifeRequest is POST …/close and …/archive: Stop stops a running turn first instead of refusing.
 */
export interface LifeRequest {
	stop?: boolean;
}
/**
 * OwnerRequest is POST …/owners.
 */
export interface OwnerRequest {
	groupId: number /* int64 */;
}
/**
 * AssigneeRequest is POST …/assignees.
 */
export interface AssigneeRequest {
	userId: number /* int64 */;
}
/**
 * PublicRequest is PUT …/previews/{name}/public: one preview's public switch.
 */
export interface PublicRequest {
	public: boolean;
}
/**
 * DriverRequest is PUT …/driver: hand the chat's session to the terminal (cli) or back to the chat
 * view (gui) at its next quiet point; Restart starts a running terminal again (cli only).
 */
export interface DriverRequest {
	driver: api.Driver;
	restart?: boolean;
}
/**
 * SetModeRequest is PUT …/mode: the mode the chat should switch to at its next quiet point.
 */
export interface SetModeRequest {
	mode: api.ChatMode;
}
/**
 * SetAgentsRequest is PUT …/agents: whether Claude in other AI chats may read this chat. The answer is
 * the chat as its page opens it.
 */
export interface SetAgentsRequest {
	available: boolean;
}
/**
 * SetCeilingRequest is PUT …/ceiling: how far Claude in this chat may go in a drive, one of
 * core.AgentLevel's words. The answer is the chat as its page opens it.
 */
export interface SetCeilingRequest {
	ceiling: string;
}
/**
 * CreateChatAnswer is POST /api/aichat/chats's answer: the new chat and its first message.
 */
export interface CreateChatAnswer {
	chat: ChatView;
	item: ItemView;
	/**
	 * Dedup is set when the request repeated an earlier create: nothing was written.
	 */
	dedup?: boolean;
}

//////////
// source: item.go

/**
 * ItemState is an item's state, a word from its kind's states in aichatapi's catalogue (a card's by
 * its type). It is a type of its own so that a durable payload can be checked for words it may carry.
 */
export type ItemState = string;
/**
 * AuthorKind says who wrote an item: a person (the item names them), Claude, or the system.
 */
export type AuthorKind = string;
export const AuthorUser: AuthorKind = "user";
export const AuthorClaude: AuthorKind = "claude";
export const AuthorSystem: AuthorKind = "system";
/**
 * ItemHead is what an item's durable event carries: where the item sits and what it is, never a word
 * of it. The client keeps the newest head per item by Version and fetches the item itself through
 * GET …/items?sinceRev= when the chat's item rev moves past what it holds.
 */
export interface ItemHead {
	chatId: number /* int64 */;
	itemId: number /* int64 */;
	/**
	 * Seq is the item's place in the chat, dense from 1 and never reused.
	 */
	seq: number /* int64 */;
	/**
	 * Rev is the chat's item rev of the item's latest write; Version counts the item's own writes.
	 */
	rev: number /* int64 */;
	version: number /* int64 */;
	kind: api.Kind;
	state: ItemState;
	authorKind: AuthorKind;
	/**
	 * AuthorId is the person who wrote the item, for a person's item only.
	 */
	authorId?: number /* int64 */;
	turnId?: number /* int64 */;
	/**
	 * ParentSeq is the seq of the workflow a workflow agent's row belongs to.
	 */
	parentSeq?: number /* int64 */;
	/**
	 * ClientOpId is the key the author sent the item with, so the author's other tabs recognise
	 * their own echo.
	 */
	clientOpId?: string;
	/**
	 * At is when the item happened: the worker machine's clock for Claude's items, clamped between
	 * the turn's delivery and teamBase's receipt; teamBase's clock for its own.
	 */
	at: number /* int64 */;
	attachmentCount?: number /* int */;
}
/**
 * ItemView is one item as a page draws it: the head, and the words. Markdown is the body of the kinds
 * that have one (prose, prompt, steer, note) and Render its parsed tree; Data is the kind's own data,
 * typed per kind by aichatapi. Every word has been masked on teamBase before it was stored.
 */
export interface ItemView extends ItemHead {
	/**
	 * Src is the item's key within its chat as its writer named it (S06 §2): what an answer names its
	 * card by, a live picture its open block and its running calls by, and what a transcript row is
	 * keyed by. It is an id, never words, and rides only the reads, not the durable events.
	 */
	src: string;
	markdown?: string;
	render?: core.Render;
	data?: unknown;
	/**
	 * Attachments are the files a person sent with a prompt or a note.
	 */
	attachments?: core.AttachmentWire[];
	/**
	 * Output is set for an item that produced an output: its size, and whether the whole of it is
	 * stored for GET …/items/{seq}/output to read.
	 */
	output?: ItemOutput;
	/**
	 * DeliveredAt is when the turn that carried a prompt was handed to Claude.
	 */
	deliveredAt?: number /* int64 */;
	/**
	 * Tombstone says an admin purged the item: its words are gone, its place stays.
	 */
	tombstone?: boolean;
	/**
	 * AskerSeen is set on an open question whose watchdog would take the recommended option: its
	 * asker has read the chat as far as the card (S01 §7), so the card says so rather than that the
	 * question will wait for her.
	 */
	askerSeen?: boolean;
	/**
	 * Call is how this reader reads a call of teamBase's tool sets (an item of kind call): the row's
	 * words, its target as this reader may see it, and a refusal's reason and cause. Set by the
	 * conversation's read; another answer that carries an item leaves it out.
	 */
	call?: CallView;
	/**
	 * CallSeq is set on a Bash row that is one set call teamBase answered (verb teambase): the seq of
	 * that call's item, which the row folds into as its opened detail. A finished Bash row naming no
	 * call teamBase recorded is served as a plain run.
	 */
	callSeq?: number /* int64 */;
}
/**
 * ItemOutput says what became of a tool's whole output. Its head and tail are in the tool's data
 * (aichatapi.OutputExcerpt), masked like every other word; this is the rest.
 */
export interface ItemOutput {
	/**
	 * Bytes is the size of the whole output.
	 */
	bytes: number /* int64 */;
	/**
	 * State says where the rest is: stored (More), or why it is not.
	 */
	state: OutputState;
	more: boolean;
}
/**
 * OutputText is one slice of a tool's whole output, read from its stored blob (GET …/items/{seq}/output).
 * Offset and Bytes count bytes of the stored output, not characters: the next slice starts at
 * Offset + Bytes, so a reader pages through an output of any size without ever cutting a character.
 * Text is always valid UTF-8; a byte the output held that was not is shown as U+FFFD.
 */
export interface OutputText {
	text: string;
	offset: number /* int64 */;
	bytes: number /* int64 */;
	/**
	 * Done says the slice reaches the end of the output.
	 */
	done: boolean;
}
/**
 * OutputState says what became of a tool's whole output: kept inline (the excerpt is all of it),
 * stored as a blob, not stored (missing or refused for the retained budget), too large for its class,
 * or pruned later to make room.
 */
export type OutputState = string;
export const OutputNone: OutputState = "none";
export const OutputInline: OutputState = "inline";
export const OutputStored: OutputState = "stored";
export const OutputNotStored: OutputState = "not_stored";
export const OutputTooLarge: OutputState = "too_large";
export const OutputPruned: OutputState = "pruned";
/**
 * ItemPage is one read of a chat's items, answered from one snapshot of the database.
 * A page by seq (the tail, before=, around=) holds top-level items in seq order; a page by sinceRev
 * holds every item written after that rev, in rev order. Rev is the chat's item rev the page is
 * complete up to: a client that applied it asks next with sinceRev = Rev and misses nothing, because
 * an item takes its rev inside the write that commits it.
 */
export interface ItemPage {
	items: ItemView[];
	rev: number /* int64 */;
	/**
	 * HasMoreBefore says older top-level items exist before the first one of the page.
	 */
	hasMoreBefore: boolean;
	/**
	 * HasMore says the page stopped early — at its limit or its byte bound — and newer items or
	 * changes follow.
	 */
	hasMore: boolean;
	/**
	 * EventId is the realtime head read before the rows: events up to it are in the page.
	 */
	eventId: number /* int64 */;
}
/**
 * MessageAck answers a person's send: the item it made, its place in the queue, why it waits if it
 * does, and whether this was a repeat of an earlier send with the same key (which wrote nothing).
 */
export interface MessageAck {
	item: ItemView;
	position?: number /* int */;
	warnings?: SendWarning[];
	dedup: boolean;
}
/**
 * SendWarning says why a prompt that was kept does not go to Claude at once; the composer words it
 * (aichat.composer.warning.<word>). A warning is never a refusal: the item is stored either way.
 */
export type SendWarning = string;
/**
 * WarnQueueHeld: an owner holds the chat's queue.
 */
export const WarnQueueHeld: SendWarning = "queueHeld";
/**
 * WarnMachineBusy: the worker machine has no room for another running chat right now.
 */
export const WarnMachineBusy: SendWarning = "machineBusy";
/**
 * WarnSwitchPending: a mode switch or a part change waits to be applied first.
 */
export const WarnSwitchPending: SendWarning = "switchPending";

//////////
// source: live.go

/**
 * LivePicture is `aichat.live`: the running turn's live state. PictureSeq rises per turn; of two
 * pictures of one turn the higher is newer. ItemRev is the chat's item rev when teamBase relayed the
 * picture, AfterSeq its last item seq: the browser draws the picture only when it has loaded every item
 * up to AfterSeq and nothing after it, so a finished block is never on screen twice. At is teamBase's
 * clock at the relay, the "now" an elapsed time is counted against.
 */
export interface LivePicture {
	chatId: number /* int64 */;
	turnId: number /* int64 */;
	pictureSeq: number /* int64 */;
	itemRev: number /* int64 */;
	afterSeq: number /* int64 */;
	at: number /* int64 */;
	body: api.LivePicture;
}
/**
 * WorkflowPicture is `aichat.workflow`: one running workflow's phases and agents, keyed by its run.
 */
export interface WorkflowPicture {
	chatId: number /* int64 */;
	turnId: number /* int64 */;
	runId: string;
	pictureSeq: number /* int64 */;
	at: number /* int64 */;
	body: api.WorkflowFrame;
}
/**
 * AgentPicture is `aichat.agent` (R1b): the newest steps of one agent somebody is reading, keyed by
 * the agent's src. It exists only while someone follows that agent.
 */
export interface AgentPicture {
	chatId: number /* int64 */;
	turnId: number /* int64 */;
	src: string;
	pictureSeq: number /* int64 */;
	at: number /* int64 */;
	body: api.AgentTail;
}
/**
 * LiveView is GET …/live: the newest pictures teamBase holds for the chat. Stale says teamBase has
 * held none since it started and waits for the host to send one again; a page then draws from its
 * items alone until the next picture arrives. Now is teamBase's clock as it answered: a held picture
 * may be minutes old (a question waiting, a long tool), and a page that opens then counts a turn's
 * time from the picture's `at` plus that age, not from the moment it asked.
 */
export interface LiveView {
	chatId: number /* int64 */;
	turnId?: number /* int64 */;
	now: number /* int64 */;
	stale: boolean;
	live?: LivePicture;
	workflows: WorkflowPicture[];
}
/**
 * TypingRequest is the `aichat.typing` socket request (R1b): the sender types in this chat's
 * composer. Who types comes from the connection, never from the body.
 */
export interface TypingRequest {
	chatId: number /* int64 */;
}
/**
 * TypingEvent is the `aichat.typing` frame the chat's other readers get: who, and when teamBase heard
 * it. The browser forgets it five seconds later unless another one comes. Terminal says the person
 * types in the chat's terminal rather than in its composer; teamBase derives it from their input.
 */
export interface TypingEvent {
	chatId: number /* int64 */;
	userId: number /* int64 */;
	at: number /* int64 */;
	terminal?: boolean;
}
/**
 * Viewers is `aichat.viewers` (R1b): everyone who has the chat on screen now, the whole set each time.
 * Terminal are those of them who have its terminal open, absent while nobody has, and SizeBy is the
 * one whose window the terminal is sized to (0 while nobody's is).
 */
export interface Viewers {
	chatId: number /* int64 */;
	userIds: number /* int64 */[];
	terminal?: number /* int64 */[];
	sizeBy?: number /* int64 */;
}
/**
 * TerminalAttach is the `aichat.terminal.attach` socket request: the caller has the chat's terminal
 * open in a window of Cols × Rows. A page sends it when the terminal opens, on a reconnect, on a gap
 * in the output, on a resize and every twenty seconds; teamBase forgets an attach that was not sent
 * again within aichatapi.FollowTTLSeconds. Redraw is the page's nonce: a new one asks for a keyframe.
 * Pump false is a hidden tab, which stays a viewer and gets no bytes; absent, the page shows the
 * screen. Leave says the page left the terminal (its size and nonce are then not read).
 */
export interface TerminalAttach {
	chatId: number /* int64 */;
	cols: number /* int */;
	rows: number /* int */;
	redraw: string;
	leave?: boolean;
	pump?: boolean;
}
/**
 * TerminalInputRequest is the `aichat.terminal.input` socket request: keys an owner typed, the
 * standard base64 of at most aichatapi.TermChunkMax bytes, against the terminal process Gen the page
 * last drew. Who typed them comes from the connection, never from the body.
 */
export interface TerminalInputRequest {
	chatId: number /* int64 */;
	gen: number /* int64 */;
	b64: string;
}
/**
 * TerminalOutput is the `aichat.terminal.output` frame: aichatapi.TerminalOutput as the host sent it,
 * with the chat it belongs to. A page applies a frame only at the offset it expects next, so a frame
 * dropped on the way shows as a gap, which a new redraw nonce heals.
 */
export interface TerminalOutput {
	chatId: number /* int64 */;
	gen: number /* int64 */;
	off: number /* int64 */;
	cols: number /* int */;
	rows: number /* int */;
	key?: boolean;
	b64: string;
}
/**
 * MaxViewers bounds Viewers.UserIds: beyond it the faces say "and more".
 */
export const MaxViewers = 50;

//////////
// source: login.go

/**
 * The states of a member login's record (aichat_login.state).
 */
export const LoginStateConnected = "connected";
/**
 * The states of a member login's record (aichat_login.state).
 */
export const LoginStateExpired = "expired";
/**
 * The states of a member login's record (aichat_login.state).
 */
export const LoginStateRefused = "refused";
/**
 * The states of a member login's record (aichat_login.state).
 */
export const LoginStateDisconnected = "disconnected";
/**
 * LoginUsage is one login as the broker's newest picture draws it, and the payload of
 * `aichat.login.changed` once the event is per login: its id, its state (aichatapi.LoginStates) since
 * when, the limit it is under while limited (until when, and which model family, "" for every model),
 * and its plan's windows when known. It never names the login's owner or label — the event goes to
 * every member who may use AI chats, and each browser matches it to the logins it shows by the id.
 */
export interface LoginUsage {
	login: string;
	state: string;
	since?: number /* int64 */;
	limitedUntil?: number /* int64 */;
	scope?: string;
	windows?: api.PlanMeter;
}
/**
 * LoginLine is one login of a member as every list draws it: the member's page, the new-chat form, the
 * plan popover's control, the admins' tab. State is the record's (MemberLoginStates; a disconnected
 * login is never listed), IsActive whether the member's requests run on it, ExpiresAt the end of the
 * day the member entered, in their own time zone. Usage is absent while teamBase has no picture of the
 * login since it started.
 */
export interface LoginLine {
	id: string;
	label: string;
	state: string;
	isActive: boolean;
	expiresAt: number /* int64 */;
	usage?: LoginUsage;
}
/**
 * MyLogin is one row of the member's page: the line, and the open chats the member may open whose
 * last request ran on it.
 */
export interface MyLogin extends LoginLine {
	chats: LoginChatLine[];
}
/**
 * LoginChatLine is a chat a login runs: its key for the link and its title for the words.
 */
export interface LoginChatLine {
	chatId: number /* int64 */;
	key: string;
	title: string;
}
/**
 * MyLoginsView is GET /api/aichat/logins: the caller's own logins that are not disconnected, the
 * active one first and then the newest, and the open chats the caller may open that hold a Claude
 * login they signed in to in the chat's terminal, the newest sign-in first.
 */
export interface MyLoginsView {
	logins: MyLogin[];
	signedIn: SignedInLine[];
}
/**
 * SignedInLine is a chat that holds its own Claude login a member signed in to: the chat's key for the
 * link, its title for the words, and since when.
 */
export interface SignedInLine extends LoginChatLine {
	since: number /* int64 */;
}
/**
 * ConnectLoginRequest is POST /api/aichat/logins: a new login, its label, the token `claude
 * setup-token` printed and the day it expires ("YYYY-MM-DD"; the server places it at the end of that
 * day in the account's own time zone). The token is a core.Secret from the moment the body is decoded:
 * it prints, logs and marshals as "[redacted]", and the one place its bytes are read is the frame that
 * carries it to the dev machine.
 */
export interface ConnectLoginRequest {
	label: string;
	token: string;
	expiresOn: string;
	makeActive?: boolean;
}
/**
 * TokenRequest is POST /api/aichat/logins/{id}/token: a new token for one of the caller's logins,
 * with its day of expiry. The id, the label and whether it is active stay.
 */
export interface TokenRequest {
	token: string;
	expiresOn: string;
}
/**
 * UpdateLoginRequest is PATCH /api/aichat/logins/{id}: a new label, or the login made the caller's
 * active one, from Settings or the plan popover. A field left out is not changed.
 */
export interface UpdateLoginRequest {
	label?: string;
	makeActive?: boolean;
}
/**
 * RunsOn is what a chat runs on (ChatView.RunsOn): its open turn's credential, else its last one's.
 * Kind is aichatapi.Auths' word. A member's token (oauth) names the login — its id, its owner by id and
 * name, its label — and that login's usage for the plan chip. The chat's own Claude login (native)
 * names the member who signed it in (UserId and Name; 0 and "" when it was signed in inside the
 * container) and, while the chat still holds that login, the Account Claude Code reports for it.
 */
export interface RunsOn {
	kind: string;
	loginId?: string;
	userId: number /* int64 */;
	name: string;
	label?: string;
	account?: string;
	usage?: LoginUsage;
}
/**
 * NativeLine is the chat's own Claude login now (ChatView.Native): the account Claude Code reports for
 * it ("" when it reports none), the member who signed it in by id and name (0 and "" when it was signed
 * in inside the container), and since when. It rides the chat's HTTP view only, never an event.
 */
export interface NativeLine {
	account?: string;
	byUserId?: number /* int64 */;
	name?: string;
	since: number /* int64 */;
}
/**
 * AdminMemberLogin is one member login as Administration → AI Chats → Claude logins lists it: the
 * line, whose it is, how many open chats ran their last request on it, and its turns of the last
 * seven days. Never a token.
 */
export interface AdminMemberLogin extends LoginLine {
	userId: number /* int64 */;
	chats: number /* int */;
	turns7d: number /* int */;
}
/**
 * AdminNativeLogin is one member as Administration → AI Chats → Claude logins' second table lists
 * them: how many open chats hold a Claude login they signed in to, and the requests those logins ran
 * in the last seven days. Never a chat, a title or an account.
 */
export interface AdminNativeLogin {
	userId: number /* int64 */;
	chats: number /* int */;
	turns7d: number /* int */;
}
/**
 * AdminLoginView is GET /api/admin/aichat/login (action admin.aichat.login.read): every member's
 * Claude logins, how many chats wait for one, and the cut-off in force. It never carries a token,
 * which teamBase does not hold.
 */
export interface AdminLoginView {
	/**
	 * MemberLogins are every member login that is not disconnected, by member and then as each
	 * member's page orders them; absent while no member has connected one.
	 */
	memberLogins?: AdminMemberLogin[];
	/**
	 * NativeLogins are the members who signed chats in to their own Claude account in a chat's
	 * terminal, by member; absent while none did.
	 */
	nativeLogins?: AdminNativeLogin[];
	/**
	 * Waiting counts the open chats whose next request waits for its login now, whoever's it is.
	 */
	waiting: number /* int */;
	/**
	 * Refused counts, by aichatapi.LoginRefusals reason, what the login broker refused in the last 24
	 * hours, over every login.
	 */
	refused: { [key: string]: number /* int */};
	/**
	 * Cutoff is the cut-off of every AI chat while an admin has one in force: the logins are fine, and
	 * no chat may use them. Absent otherwise.
	 */
	cutoff?: LoginCutoff;
}
/**
 * LoginCutoff is a cut-off in force: since when, on which admin's word and for which of the operator
 * verb's reasons, and the command that lifts it on the server.
 */
export interface LoginCutoff {
	at: number /* int64 */;
	by: number /* int64 */;
	reason: string;
	command: string;
}
/**
 * CutoffLiftCommand is LoginCutoff.Command before its reason: an admin runs it on the teamBase server,
 * naming themselves. Lifting restarts nothing; a chat that paused meanwhile waits for its Continue.
 */
export const CutoffLiftCommand = "sudo teambase aichat cutoff --all --off --by <your handle> --reason";

//////////
// source: naming.go

/**
 * How the browser names a chat, and the names of every refusal the module answers with.
 * A chat is its key in every address: the page /ai/<key>, the routes /api/aichat/chats/<key>/…. The
 * key's alphabet and length are aichatapi's (KeyAlphabet, KeyLength), because the worker machine's
 * preview gateway parses keys too; KeyPattern is the same grammar as one expression, for the router
 * and the browser's route table. A malformed key, an unknown key and a chat the caller does not own
 * all answer ErrNotFound: an address never tells a stranger whether a chat exists.
 */
export const KeyPattern = `^[2-9a-hjkmnp-z]{8}\$`;
/**
 * ChatPathPrefix is where a chat's page lives in the browser: ChatPathPrefix + key.
 */
export const ChatPathPrefix = "/ai/";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrNotFound = "error.aichat.notFound";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrClientOpIDInvalid = "error.aichat.clientOpIdInvalid";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrCrossed = "error.aichat.crossed";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrChatClosed = "error.aichat.chatClosed";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrTurnOpen = "error.aichat.turnOpen";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrNotRunning = "error.aichat.notRunning";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrNotPaused = "error.aichat.notPaused";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrSteerNotAsker = "error.aichat.steerNotAsker";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrNotAuthor = "error.aichat.notAuthor";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrItemChanged = "error.aichat.itemChanged";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrAlreadyDelivered = "error.aichat.alreadyDelivered";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrCardAnswered = "error.aichat.cardAnswered";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrCardClosed = "error.aichat.cardClosed";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrChoiceInvalid = "error.aichat.choiceInvalid";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrCommandUnknown = "error.aichat.commandUnknown";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrCommandBlocked = "error.aichat.commandBlocked";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrArgumentInvalid = "error.aichat.argumentInvalid";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrNeedsQuiet = "error.aichat.needsQuiet";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrAskNotAvailable = "error.aichat.askNotAvailable";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrPromptEmpty = "error.aichat.promptEmpty";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrPromptTooLong = "error.aichat.promptTooLong";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrModeInvalid = "error.aichat.modeInvalid";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrReadOnly = "error.aichat.readOnly";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrGroupUnknown = "error.aichat.groupUnknown";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrTooManyGroups = "error.aichat.tooManyGroups";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrNotAnOwner = "error.aichat.notAnOwner";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrTitleInvalid = "error.aichat.titleInvalid";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrRevChanged = "error.aichat.revChanged";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLastOwnerGroup = "error.aichat.lastOwnerGroup";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLandingOpen = "error.aichat.landingOpen";
/**
 * ErrRefusedWork is a switch to read or a part removal while Claude's last work was refused at
 * its capture: it exists only in the chat's copy, which the change would undo.
 */
export const ErrRefusedWork = "error.aichat.refusedWork";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrRestoreNotOffered = "error.aichat.restoreNotOffered";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrRevisionMoved = "error.aichat.revisionMoved";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrPublishBlocked = "error.aichat.publishBlocked";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrDevelopersRequired = "error.aichat.developersRequired";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrReviewExcluded = "error.aichat.reviewExcluded";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrPublicDisabled = "error.aichat.publicDisabled";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrPublicNative = "error.aichat.publicNative";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrRateLimited = "error.aichat.rateLimited";
/**
 * ErrTooManyAssignees is the assignee list at its ceiling of MaxAssignees.
 */
export const ErrTooManyAssignees = "error.aichat.tooManyAssignees";
/**
 * ErrFilterInvalid is a home list filter that is not one of ChatFilters.
 */
export const ErrFilterInvalid = "error.aichat.filterInvalid";
/**
 * ErrNoPreview is a preview asked of a chat that has none of that name now: it may not run it, or
 * no configured part names it (NoPreviewDetail says which).
 */
export const ErrNoPreview = "error.aichat.preview.noPreview";
/**
 * ErrPreviewNotPresent is a preview's start, stop or restart pressed while the chat's environment
 * is not present (NotPresentDetail names its word).
 */
export const ErrPreviewNotPresent = "error.aichat.preview.notPresent";
/**
 * ErrEnvBusy is a reset, a reactivation, Run the checks again or Update to latest while the
 * environment is deactivating, reactivating or resetting.
 */
export const ErrEnvBusy = "error.aichat.envBusy";
/**
 * ErrEnvNothing is a reset of a chat that has no environment yet.
 */
export const ErrEnvNothing = "error.aichat.envNothing";
/**
 * The answers of connecting a Claude login or entering a new token (S17 §2): nothing is saved
 * after any of them. The dev machine is not reachable, Claude refused the token, the dev machine
 * did not confirm it in time, the label is one of the caller's, the caller holds as many logins
 * as one may, the dev machine holds as many as it can, the expiry is not in the future, or what was
 * pasted is not a token.
 */
export const ErrLoginMachineAway = "error.aichat.loginMachineAway";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginRefused = "error.aichat.loginRefused";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginNoAnswer = "error.aichat.loginNoAnswer";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginLabelTaken = "error.aichat.loginLabelTaken";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginTooMany = "error.aichat.loginTooMany";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginMachineFull = "error.aichat.loginMachineFull";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginExpiryPast = "error.aichat.loginExpiryPast";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginTokenShape = "error.aichat.loginTokenShape";
/**
 * ErrLoginNone is a message from a member with no Claude login to run it on; ErrLoginUnusable one
 * whose active login does not work now (expired, refused, or not on the dev machine).
 */
export const ErrLoginNone = "error.aichat.loginNone";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrLoginUnusable = "error.aichat.loginUnusable";
/**
 * ErrNativeNone is the chat view's /logout in a chat that holds no Claude login of its own.
 */
export const ErrNativeNone = "error.aichat.nativeNone";
/**
 * The refusals of the two drivers: a driver press that names neither driver (or restarts the chat
 * view), a press while another waits for the session's quiet point (its data names where that one
 * goes), Start in a chat whose environment is deactivated, keys typed while no terminal runs, and
 * an answer or an addition that belongs in the terminal — a question or plan Claude asked there,
 * and a line added to a turn typed there.
 */
export const ErrDriverInvalid = "error.aichat.driverInvalid";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrDriverPending = "error.aichat.driverPending";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrDriverEnvAway = "error.aichat.driverEnvAway";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrTerminalNotRunning = "error.aichat.terminalNotRunning";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrAnswerInTerminal = "error.aichat.answerInTerminal";
/**
 * Every refusal of the module is one of these locale keys (S03 §10), with its copy in
 * web/src/modules/aichat/i18n/en.ts. A new refusal is added here first.
 */
export const ErrTurnInTerminal = "error.aichat.turnInTerminal";
/**
 * The ceilings of a chat's people lists (S01 §3): owner groups and assignees, 16 each.
 */
export const MaxOwnerGroups = 16;
/**
 * The ceilings of a chat's people lists (S01 §3): owner groups and assignees, 16 each.
 */
export const MaxAssignees = 16;

//////////
// source: preview.go

/**
 * PreviewNamePattern is a preview's name as one expression, for the router and the browser:
 * aichatapi.PreviewNamePattern's grammar, which a test holds equal.
 */
export const PreviewNamePattern = `^[a-z][a-z0-9]{1,11}\$`;
/**
 * PreviewsView is GET …/previews: each preview of the chat, defaults first in their parts' order and
 * then the others by name, with what the panel shows beyond its line; PublicAllowed says whether the
 * admins allow public previews at all. Native, NativeAccount and MCPServers are what a public
 * switch's confirm names: whether the chat holds its own Claude login, its account or signer ("" when
 * it names neither, or without one) and the MCP servers its owners connected — read over HTTP only,
 * never on a durable row.
 */
export interface PreviewsView {
	previews: PreviewDetail[];
	publicAllowed: boolean;
	native?: boolean;
	nativeAccount?: string;
	mcpServers?: string[];
}
/**
 * PreviewLine is one preview of a chat as every list, the band and `aichat.preview.changed` carry
 * it: ids and words only, never its title, since the line rides durable events. Name is the preview's
 * name and Kind what it shows (aichatapi.PreviewKinds); Host its address, <key>-<name>.<domain> (""
 * while teamBase serves no previews). State is the machine's state of it, or off while the chat may
 * not run it now (PreviewLineStates), since Since; OffCause says why it is off (OffCauses). Public is
 * whether an owner made it public, in effect. Failure is why a failed preview stopped
 * (aichatapi.PreviewFailures), and StartMs how long its last finished start took. HasLogins and
 * HasMail say its declaration names a sign-in accounts file and a mail folder, so the panel offers
 * them.
 */
export interface PreviewLine {
	chatId: number /* int64 */;
	rev: number /* int64 */;
	name: api.PreviewName;
	kind: api.PreviewKind;
	host: string;
	state: string;
	since?: number /* int64 */;
	offCause?: string;
	public: boolean;
	failure?: string;
	startMs?: number /* int64 */;
	hasLogins?: boolean;
	hasMail?: boolean;
}
/**
 * PreviewDetail is one preview as the previews panel shows it to the chat's owners: its line, its
 * title ("" when its declaration gives none), a page's folder, the newest line of a command's output,
 * the last command the host ran for it with its exit and tail (both masked), and Pending, a press not
 * carried out yet (aichatapi.PreviewActions).
 */
export interface PreviewDetail extends PreviewLine {
	title?: string;
	folder?: string;
	line?: string;
	last?: api.PreviewLast;
	pending?: string;
}
/**
 * PanelView is GET …/previews/{name}/panel: the sign-in accounts and the newest mail of one preview,
 * as the worker last read them while the panel was open. The route is a long-poll on At (the
 * worker's read; 0 while there is none yet), and reading it keeps the panel's lease, so the worker
 * reads again only while somebody looks. LoginsProblem says why there are no accounts
 * (aichatapi.LoginsProblems): the panel then tells the owners to ask the chat. A password here is a
 * previewed system's test account, never a production one.
 */
export interface PanelView {
	name: api.PreviewName;
	at: number /* int64 */;
	logins: api.PanelLogin[];
	loginsProblem?: string;
	mail: api.PanelMail[];
}
/**
 * NoPreviewDetail is the detail of 409 error.aichat.preview.noPreview: why, and whether the reader may
 * switch the chat so that it gets one; Host is the address the preview would have.
 */
export interface NoPreviewDetail {
	key: string;
	host: string;
	reason: string;
	canSwitch: boolean;
	/**
	 * Name is the preview that was asked for.
	 */
	name: api.PreviewName;
}
/**
 * NotPresentDetail is the detail of 409 error.aichat.preview.notPresent: a preview's start, stop or
 * restart pressed while the chat's environment is not present, with the environment's word
 * (EnvWords) — a deactivated chat offers Reactivate instead.
 */
export interface NotPresentDetail {
	key: string;
	env: string;
}
/**
 * The states of an access request (S10 §6): waiting, settled by the requester getting in (an owner
 * added them, or the preview went public), dismissed by an owner, or lapsed when the chat closed.
 */
export const AccessOpen = "open";
/**
 * The states of an access request (S10 §6): waiting, settled by the requester getting in (an owner
 * added them, or the preview went public), dismissed by an owner, or lapsed when the chat closed.
 */
export const AccessOpened = "opened";
/**
 * The states of an access request (S10 §6): waiting, settled by the requester getting in (an owner
 * added them, or the preview went public), dismissed by an owner, or lapsed when the chat closed.
 */
export const AccessDismissed = "dismissed";
/**
 * The states of an access request (S10 §6): waiting, settled by the requester getting in (an owner
 * added them, or the preview went public), dismissed by an owner, or lapsed when the chat closed.
 */
export const AccessLapsed = "lapsed";
/**
 * AccessRequestRow is one visitor's request to open a private preview (S10 §6).
 */
export interface AccessRequestRow {
	id: number /* int64 */;
	requester: AccessPerson;
	createdAt: number /* int64 */;
	state: string;
	canOpenNow: boolean;
	/**
	 * Name is the preview the visitor asked to open.
	 */
	name: api.PreviewName;
}
/**
 * AccessPerson is who asked: "Add <name> as owner" adds their personal group, which CanOwn says is
 * allowed (a guest's is not).
 */
export interface AccessPerson {
	id: number /* int64 */;
	name: string;
	handle: string;
	personalGroupId: number /* int64 */;
	canOwn: boolean;
}
/**
 * AccessRequestList is GET …/access-requests.
 */
export interface AccessRequestList {
	requests: AccessRequestRow[];
}
/**
 * AccessChanged is `aichat.access.changed`: a request was made, granted or dismissed. It names people
 * by id only.
 */
export interface AccessChanged {
	chatId: number /* int64 */;
	requestId: number /* int64 */;
	requesterId: number /* int64 */;
	state: string;
	at: number /* int64 */;
	name: api.PreviewName;
}

//////////
// source: preview_visitor.go

/**
 * Refusals of the visitor routes. A label that names nothing, a chat the caller may not open, and a
 * closed chat or one without that preview of somebody else's all answer cannotOpen alike; only an
 * owner learns that the chat is closed (chatClosed, ChatClosedDetail) or why it has no preview
 * (ErrNoPreview, NoPreviewDetail).
 */
export const ErrPreviewCannotOpen = "error.aichat.preview.cannotOpen";
/**
 * Refusals of the visitor routes. A label that names nothing, a chat the caller may not open, and a
 * closed chat or one without that preview of somebody else's all answer cannotOpen alike; only an
 * owner learns that the chat is closed (chatClosed, ChatClosedDetail) or why it has no preview
 * (ErrNoPreview, NoPreviewDetail).
 */
export const ErrPreviewChatClosed = "error.aichat.preview.chatClosed";
/**
 * CannotOpenDetail is the detail of 404 error.aichat.preview.cannotOpen: the preview's address, which
 * follows from the label alone and so tells nothing about the chat. teamBase's visitor pages show it
 * and send a browser back to it; a label that names no preview host has none.
 */
export interface CannotOpenDetail {
	host?: string;
}
/**
 * ChatClosedDetail is the detail of 409 error.aichat.preview.chatClosed: the key, so the page offers
 * to open the chat and to reopen it, and the preview's address it names.
 */
export interface ChatClosedDetail {
	key: string;
	host: string;
}
/**
 * PassRequest is POST /api/aichat/preview/{label}/pass: the hash of the state the preview host planted
 * in this browser (43 base64url characters), and where on the preview to land.
 */
export interface PassRequest {
	h: string;
	r: string;
}
/**
 * PassAnswer is the pass route's answer: the preview host's ticket address, which the page replaces
 * itself with at once.
 */
export interface PassAnswer {
	location: string;
}
/**
 * The viewers of a preview's state: an owner of the chat, or anybody on a public preview.
 */
export const ViewerOwner = "owner";
/**
 * The viewers of a preview's state: an owner of the chat, or anybody on a public preview.
 */
export const ViewerPublic = "public";
/**
 * WaitingBusy says the worker holds the container or the preview in its start line, behind a full
 * running budget: the Starting page says the dev machine is busy and keeps asking.
 */
export const WaitingBusy = "busy";
/**
 * PreviewStateAnswer is GET /api/aichat/preview/{label}/state and the wake's answer: the preview's
 * state for the Starting page. Name names the preview of the address; State is one of
 * PreviewLineStates — off while the chat may not run it or has no container (a visit never brings a
 * deactivated chat back) — since Since. Waiting is busy while the worker holds it in its start line.
 * Owner holds the chat's facts, for owners alone (how long the last start took among them).
 */
export interface PreviewStateAnswer {
	name: api.PreviewName;
	state: string;
	since: number /* int64 */;
	host: string;
	viewer: string;
	waiting?: string;
	owner?: PreviewOwnerFacts;
}
/**
 * PreviewOwnerFacts is what only owners read on the Starting page: the chat by key and title, the
 * environment's word (EnvWords: a deactivated chat offers Reactivate), why a failed preview failed
 * (aichatapi.PreviewFailures), the newest line of its output (masked) and how long its last start
 * took.
 */
export interface PreviewOwnerFacts {
	key: string;
	title: string;
	env: string;
	failure?: string;
	line?: string;
	startMs?: number /* int64 */;
}

//////////
// source: requests.go

/**
 * The kinds of a person's message (SendRequest.Kind): a request for Claude, a note for the team that
 * Claude never reads, or words given to the running turn.
 */
export const MessagePrompt = "prompt";
/**
 * The kinds of a person's message (SendRequest.Kind): a request for Claude, a note for the team that
 * Claude never reads, or words given to the running turn.
 */
export const MessageNote = "note";
/**
 * The kinds of a person's message (SendRequest.Kind): a request for Claude, a note for the team that
 * Claude never reads, or words given to the running turn.
 */
export const MessageSteer = "steer";
/**
 * CrossedSendAnyway is SendRequest.Crossed after a 409 crossed: the author read the other messages
 * and sends theirs as it is.
 */
export const CrossedSendAnyway = "sendAnyway";
/**
 * SendRequest is POST …/messages. SeenSeq is the newest seq the author had seen when they sent: a
 * message by someone else after it refuses the send once (409 crossed). Jump is "Send next" under a
 * hold.
 */
export interface SendRequest {
	clientOpId: string;
	markdown: string;
	attachments?: core.AttachmentRef[];
	seenSeq: number /* int64 */;
	kind?: string;
	planFirst?: boolean;
	jump?: boolean;
	crossed?: string;
}
/**
 * CrossedDetail is the detail of 409 crossed: the other people's messages the author has not seen, at
 * most five.
 */
export interface CrossedDetail {
	items: ItemView[];
}
/**
 * EditRequest is PATCH …/items/{seq}: the author's new words for a waiting message, against the version
 * they edited. Attachments is the whole set the message keeps.
 */
export interface EditRequest {
	clientOpId: string;
	markdown: string;
	attachments?: core.AttachmentRef[];
	version: number /* int64 */;
}
/**
 * WithdrawRequest is POST …/items/{seq}/withdraw.
 */
export interface WithdrawRequest {
	clientOpId: string;
}
/**
 * EditingRequest is PUT …/items/{seq}/editing: the author has the queue's head open in the editor,
 * which holds its delivery for up to ten minutes.
 */
export interface EditingRequest {
	on: boolean;
}
/**
 * ItemAnswer is the answer of the routes that make one item: a Continue, a command, an Ask, a card's
 * answer, a withdraw in the delivery gap.
 */
export interface ItemAnswer {
	item: ItemView;
}
/**
 * ContinueRequest is POST …/continue. Model is "Continue with Sonnet": a model outside a limit's
 * scope, set as the chat's model first.
 */
export interface ContinueRequest {
	clientOpId: string;
	model?: string;
}
/**
 * QueueRequest is PUT …/queue: hold or release the chat's queue.
 */
export interface QueueRequest {
	held: boolean;
}
/**
 * StopRequest is POST …/stop: the turn to stop and, for "Stop and send", the caller's own waiting
 * message that runs next.
 */
export interface StopRequest {
	turnId: number /* int64 */;
	then?: number /* int64 */;
}
/**
 * StopAnswer is its 202: the turn being stopped.
 */
export interface StopAnswer {
	turnId: number /* int64 */;
}
/**
 * TaskStopRequest is POST …/tasks/{taskId}/stop: one background task or workflow of the running turn.
 */
export interface TaskStopRequest {
	turnId: number /* int64 */;
}
/**
 * CardAnswerRequest is POST …/cards/{seq}/answer. The choice has one of four shapes by the card: a
 * question's options or own text (or Skip), a plan's Approve with Feedback, SetAside for a parked card,
 * Modify for Claude's request to change code.
 */
export interface CardAnswerRequest {
	clientOpId: string;
	choice: CardChoice;
}
/**
 * CardChoice is the answer itself. OptionIds name options by "<question>.<option>" indexes; Text is the
 * owners' own answer, or the words sent with a modify answer.
 */
export interface CardChoice {
	optionIds?: string[];
	text?: string;
	skip?: boolean;
	approve?: boolean;
	feedback?: string;
	setAside?: boolean;
	modify?: api.AnswerChoice;
}
/**
 * CardAnsweredDetail is the detail of 409 cardAnswered: who answered first, and with what.
 */
export interface CardAnsweredDetail {
	answeredBy: number /* int64 */;
	answer: api.AnswerChoice;
}
/**
 * CommandRequest is POST …/commands: a catalogue name (with or without its slash) and the rest of the
 * typed line.
 */
export interface CommandRequest {
	clientOpId: string;
	name: string;
	args?: string;
	seenSeq?: number /* int64 */;
}
/**
 * CommandsView is GET …/commands: the catalogue as this chat offers it, the models it may run, the
 * effort levels the host reported for them, and the Asks.
 */
export interface CommandsView {
	rows: CommandRow[];
	models: ModelRow[];
	efforts: string[];
	asks: AskRow[];
}
/**
 * CommandRow is one command of the palette: aichatapi's catalogue row, and for a command the chat's
 * repositories bring, the hint and the description the CLI reported for it.
 */
export interface CommandRow extends api.Command {
	argumentHint?: string;
	description?: string;
}
/**
 * AskRow is one of S17's Asks as the palette and the doors offer it: available now, or why not (a
 * copy key).
 */
export interface AskRow {
	id: string;
	available: boolean;
	reasonKey?: string;
}
/**
 * AskText is GET …/asks/{id}: exactly the text Claude would receive, as teamBase renders it.
 */
export interface AskText {
	id: string;
	text: string;
}
/**
 * AskRequest is POST …/asks/{id}: the presser's own words to send with it, if any.
 */
export interface AskRequest {
	clientOpId: string;
	words?: string;
	seenSeq: number /* int64 */;
}
/**
 * ReadRequest is POST …/read: the reader has seen up to Seq. Auto says the viewport moved it, not a
 * click; UnreadFrom marks the chat unread from that seq.
 */
export interface ReadRequest {
	seq: number /* int64 */;
	version: number /* int64 */;
	auto?: boolean;
	unreadFrom?: number /* int64 */;
}
/**
 * ContextView is GET …/context: how full the conversation's context is. Live is false when the numbers
 * are the last turn's (no Claude is running), and then Categories are absent.
 */
export interface ContextView {
	at: number /* int64 */;
	live: boolean;
	totalTokens: number /* int64 */;
	maxTokens: number /* int64 */;
	autoCompactAt: number /* int64 */;
	categories?: ContextCategory[];
}
/**
 * ContextCategory is one part of the context: its name as the CLI reports it, its size and its kind.
 */
export interface ContextCategory {
	name: string;
	tokens: number /* int64 */;
	kind: string;
}
/**
 * AgentCalls is GET …/agents/{src}/calls (R1b): one helper or workflow agent and a page of its calls,
 * from its stored steps once it finished, from teamBase's newest tail while it runs.
 */
export interface AgentCalls {
	agent: ItemView;
	calls: ItemView[];
	next?: number /* int */;
	running: boolean;
}
/**
 * IntegrateRequest is POST …/base/integrate: queue S17's integrate text as the caller's request.
 */
export interface IntegrateRequest {
	clientOpId: string;
	seenSeq: number /* int64 */;
}
/**
 * FileRef names one file of a revision.
 */
export interface FileRef {
	repo: string;
	path: string;
}
/**
 * What a diff is taken against: the revision's base, an earlier revision ("r<k>"), one commit
 * ("commit:<id>"), or the uncommitted files.
 */
export const AgainstBase = "base";
/**
 * What a diff is taken against: the revision's base, an earlier revision ("r<k>"), one commit
 * ("commit:<id>"), or the uncommitted files.
 */
export const AgainstWip = "wip";
/**
 * DiffRequest is POST …/revisions/{n}/diff: up to twenty files. Ws ignores whitespace.
 */
export interface DiffRequest {
	files: FileRef[];
	against: string;
	ws?: boolean;
}
/**
 * The sides of a file (TextRequest.Side).
 */
export const SideOld = "old";
/**
 * The sides of a file (TextRequest.Side).
 */
export const SideNew = "new";
/**
 * TextRequest is POST …/revisions/{n}/text: one side of one file.
 */
export interface TextRequest {
	repo: string;
	path: string;
	side: string;
}
/**
 * ChecksRunRequest is POST …/revisions/{n}/checks: run the checks again after they could not run.
 */
export interface ChecksRunRequest {
	clientOpId: string;
}
/**
 * ChecksRunAnswer is its 202: the run now under way (a live run for the same heads answers itself).
 */
export interface ChecksRunAnswer {
	runId: number /* int64 */;
}
/**
 * RestoreByClaude is RestoreRequest.By when Claude restores after a conflict, as the caller's turn.
 */
export const RestoreByClaude = "claude";
/**
 * RestoreRequest is POST …/revisions/{n}/restore (R1b).
 */
export interface RestoreRequest {
	clientOpId: string;
	by?: string;
}
/**
 * PublishRequest is POST …/landings: the revision and the head of every repository as the review page
 * showed them, and for a Developer what to publish past (OverrideTests, OverrideChecksUnavailable).
 */
export interface PublishRequest {
	clientOpId: string;
	n: number /* int64 */;
	heads: { [key: string]: string};
	override?: string;
}
/**
 * PublishAnswer is its 202: the landing that now runs, or the live one a repeated press answers with.
 */
export interface PublishAnswer {
	landingId: number /* int64 */;
}
/**
 * PublishBlockedDetail is the detail of 409 publishBlocked: the Publish button as it stands now.
 */
export interface PublishBlockedDetail {
	publish: PublishView;
}
/**
 * RevisionMovedDetail is the detail of 409 revisionMoved: the revision that is latest now.
 */
export interface RevisionMovedDetail {
	latest: number /* int64 */;
}
/**
 * ReviewAskRequest is POST …/review-request, "Ask a developer": once per revision.
 */
export interface ReviewAskRequest {
	clientOpId: string;
	n: number /* int64 */;
}

//////////
// source: review.go

/**
 * RevisionList is GET …/revisions: newest first.
 */
export interface RevisionList {
	revisions: RevisionRow[];
}
/**
 * RevisionRow is one revision as the picker, the chat's done card and the base line draw it.
 */
export interface RevisionRow {
	n: number /* int64 */;
	cause: RevisionCause;
	at: number /* int64 */;
	/**
	 * TurnId and TurnN name the turn a revision of cause claude closed (TurnN counts the chat's turns).
	 */
	turnId?: number /* int64 */;
	turnN?: number /* int64 */;
	/**
	 * AskerId is the person whose request the turn was; PromptLine the first line of that request, at
	 * most 80 characters, in the asker's words.
	 */
	askerId?: number /* int64 */;
	promptLine?: string;
	/**
	 * RestoredFrom is the revision a restore went back to; ByUserId who pressed it (or updated the base).
	 */
	restoredFrom?: number /* int64 */;
	byUserId?: number /* int64 */;
	reviewable: boolean;
	/**
	 * Start says every repository's head is its base and nothing is uncommitted: "the start".
	 */
	start: boolean;
	restorable: boolean;
	/**
	 * Wip says the revision holds uncommitted files.
	 */
	wip: boolean;
	/**
	 * MainMoved is set on a revision of cause base: the repositories whose base it moved onto their
	 * newer main, in landing order — also after a Publish, when the move changed no file.
	 */
	mainMoved?: string[];
	landing?: LandingHead;
	since?: SinceCounts;
	repos: RevisionRepoIn[];
	/**
	 * Areas are the revision's three largest areas, by S14's area names.
	 */
	areas: AreaLine[];
	checks: ChecksLine;
}
/**
 * RevisionRepoIn is the size of a revision's change in one repository.
 */
export interface RevisionRepoIn {
	repo: string;
	part: string;
	files: number /* int */;
	added: number /* int */;
	removed: number /* int */;
}
/**
 * AreaLine is one area of a revision, by name, with its changed files.
 */
export interface AreaLine {
	name: string;
	files: number /* int */;
}
/**
 * The marks of a file or a commit against an earlier revision (S14 §2 "since revision k").
 */
export const MarkUnchanged = "unchanged";
/**
 * The marks of a file or a commit against an earlier revision (S14 §2 "since revision k").
 */
export const MarkAdapted = "adapted";
/**
 * The marks of a file or a commit against an earlier revision (S14 §2 "since revision k").
 */
export const MarkNew = "new";
/**
 * The marks of a file or a commit against an earlier revision (S14 §2 "since revision k").
 */
export const MarkGone = "gone";
/**
 * SinceCounts count a revision's files by their mark against revision K (the one before, unless the
 * reader chose another).
 */
export interface SinceCounts {
	k?: number /* int64 */;
	unchanged: number /* int */;
	adapted: number /* int */;
	new: number /* int */;
	gone: number /* int */;
}
/**
 * RevisionView is GET …/revisions/{n}. Repos are in landing order: the parts in the configuration's
 * order, each part's repositories in its order. Notes are Claude's closing words of the turns since the
 * last publish, drawn as Claude's.
 */
export interface RevisionView {
	row: RevisionRow;
	repos: RepoRev[];
	commits: CommitRow[];
	gate: GateView;
	publish: PublishView;
	summary: ReviewSummary;
	notes: ItemView[];
	checks: ChecksView;
}
/**
 * Where a repository's branch stands against main by the last fetch: its base is main, main has its
 * head already (an earlier publish put it there), or main has moved past its base.
 */
export const OnMainCurrent = "current";
/**
 * Where a repository's branch stands against main by the last fetch: its base is main, main has its
 * head already (an earlier publish put it there), or main has moved past its base.
 */
export const OnMainLanded = "landed";
/**
 * Where a repository's branch stands against main by the last fetch: its base is main, main has its
 * head already (an earlier publish put it there), or main has moved past its base.
 */
export const OnMainBehind = "behind";
/**
 * RepoRev is one repository of a revision: its part and its place under `src`, its base on main and
 * its head, whether uncommitted files are left, its git state (a RevisionRepoStates word) and how far
 * its base is behind main now.
 */
export interface RepoRev {
	repo: string;
	part: string;
	place: string;
	base: string;
	head: string;
	wip?: boolean;
	state: string;
	behind: number /* int */;
	onMain: string;
}
/**
 * The git state of a repository of a revision (S08 §3): clean, or the first reason it cannot be
 * reviewed.
 */
export const RepoClean = "clean";
/**
 * The git state of a repository of a revision (S08 §3): clean, or the first reason it cannot be
 * reviewed.
 */
export const RepoWip = "wip";
/**
 * The git state of a repository of a revision (S08 §3): clean, or the first reason it cannot be
 * reviewed.
 */
export const RepoMerge = "merge";
/**
 * The git state of a repository of a revision (S08 §3): clean, or the first reason it cannot be
 * reviewed.
 */
export const RepoGitOp = "git_op";
/**
 * The git state of a repository of a revision (S08 §3): clean, or the first reason it cannot be
 * reviewed.
 */
export const RepoDetached = "detached";
/**
 * CommitRow is one commit of a revision, oldest first per repository. Subject is the commit's first
 * line; AuthorId the person the commit is attributed to (the turn's asker), and Mark how the commit
 * relates to the previous revision's.
 */
export interface CommitRow {
	repo: string;
	id: string;
	subject: string;
	authorId?: number /* int64 */;
	/**
	 * CarriedBy is the asker of the request in which teamBase carried this commit onto a newer main,
	 * when that is not its author: the patch the author last saw may differ from this one.
	 */
	carriedBy?: number /* int64 */;
	at: number /* int64 */;
	mark?: string;
	/**
	 * Body is the message after its subject line, trailers included, exactly as it lands.
	 */
	body: string;
}
/**
 * GateView is the content gate's verdict on the revision (S08 §7): what teamBase refuses to publish,
 * the protected paths a Developer confirms, and the counts it read. Codes are gitflow's words, drawn as
 * aichat.gate.<code>.
 */
export interface GateView {
	refusals: GateRefusal[];
	protected: GateProtect[];
	stats: GateStats;
}
/**
 * GateRefusal is one reason teamBase never publishes the revision as it is.
 */
export interface GateRefusal {
	code: string;
	repo: string;
	path?: string;
	commit?: string;
}
/**
 * GateProtect is one protected path the revision changes, with the rule that protects it.
 */
export interface GateProtect {
	repo: string;
	path: string;
	rule: string;
}
/**
 * GateStats are the size of what the gate read.
 */
export interface GateStats {
	commits: number /* int */;
	files: number /* int */;
	added: number /* int */;
	removed: number /* int */;
}
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishPublishing = "publishing";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishReadOnly = "read_only";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishNotLatest = "not_latest";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishWorking = "working";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishPreparing = "preparing";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishNothing = "nothing";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishPublished = "published";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishUncommitted = "uncommitted";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishGitOpen = "git_open";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishRefused = "refused";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishConflict = "conflict";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishBehind = "behind";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishLandingBusy = "landing_busy";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishChecksPending = "checks_pending";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishBuildWorse = "build_worse";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishChecksUnavailable = "checks_unavailable";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishTestsWorse = "tests_worse";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishNeedsDeveloper = "needs_developer";
/**
 * The states of the Publish button (S14 §6), in the order their rows are tried: the first that holds
 * wins. The copy is aichat.review.publish.<state>.
 */
export const PublishReady = "ready";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextSwitchModify = "switch_modify";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextShowLatest = "show_latest";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextAskCommit = "ask_commit";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextAskFinish = "ask_finish";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextAskRemove = "ask_remove";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextIntegrate = "integrate";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextUpdate = "update";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextAskFix = "ask_fix";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextRerunChecks = "rerun_checks";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextAskDeveloper = "ask_developer";
/**
 * The one next step a Publish state offers (S14 §6); the copy is aichat.review.next.<step>.
 */
export const NextShareForReview = "share_for_review";
/**
 * NextReactivate is where Publish waits on the worker machine (behind, checks pending) of a chat
 * whose environment is deactivated: the press runs the chat's `reactivate` command.
 */
export const NextReactivate = "reactivate";
/**
 * The two things a Developer may publish past (PublishRequest.Override).
 */
export const OverrideTests = "tests";
/**
 * The two things a Developer may publish past (PublishRequest.Override).
 */
export const OverrideChecksUnavailable = "checks_unavailable";
/**
 * PublishView is the Publish button as S14's one function decides it for the reader: the state,
 * whether the press is possible, what a Developer would publish past, and the one next step. Rest says
 * an earlier publish landed only part of the chat's repositories; the button then reads "Publish the
 * rest…". The same view is the detail of 409 publishBlocked, so a dialog redraws from a refusal exactly
 * as the button would.
 */
export interface PublishView {
	state: string;
	n: number /* int64 */;
	detail: PublishDetail;
	canPress: boolean;
	override?: string;
	protected: boolean;
	rest: boolean;
	next?: string;
}
/**
 * PublishDetail holds the numbers and facts the state's sentence names: checks done of total, when a
 * developer was asked, why an update did not happen, the sites that got the change, and how the last
 * attempt ended.
 */
export interface PublishDetail {
	done?: number /* int */;
	total?: number /* int */;
	askedAt?: number /* int64 */;
	reason?: string;
	since?: number /* int64 */;
	parts?: string[];
	lastAttempt?: LastAttempt;
}
/**
 * LastAttempt is a publish attempt that ended refused or failed: when, and its failure class.
 */
export interface LastAttempt {
	at: number /* int64 */;
	code: string;
}
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskRefused = "refused";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskProtected = "protected";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskBaseAdapted = "base_adapted";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskDeleted = "deleted";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskSecretShaped = "secret_shaped";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskInvisibleChars = "invisible_chars";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskNonASCIIPath = "non_ascii_path";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskLargeFile = "large_file";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskBinary = "binary";
/**
 * The kinds of a risk row (S14 §5), in drawing order. The copy is aichat.review.risk.<kind>.
 */
export const RiskGenerated = "generated";
/**
 * ReviewSummary is the Summary layer's facts: the size of the change, the risk rows, the areas, and
 * what changed since an earlier revision.
 */
export interface ReviewSummary {
	facts: SummaryFacts;
	risks: RiskRow[];
	areas: AreaRow[];
	folded: FoldedCounts;
	since?: SinceCounts;
}
/**
 * SummaryFacts is the size of a revision and who asked for its commits.
 */
export interface SummaryFacts {
	commits: number /* int */;
	repos: string[];
	parts: string[];
	files: number /* int */;
	added: number /* int */;
	removed: number /* int */;
	deleted: number /* int */;
	renamed: number /* int */;
	binary: number /* int */;
	askers: AskerCommit[];
}
/**
 * AskerCommit counts one asker's commits in a revision.
 */
export interface AskerCommit {
	userId: number /* int64 */;
	commits: number /* int */;
}
/**
 * RiskRow is one risk of a revision: never folded, never paged. Paths show at most 50; Total counts
 * them all. Why is the configured sentence of a part's own protected paths or of a sensitive path —
 * teamBase's words, drawn instead of the rule's copy.
 */
export interface RiskRow {
	kind: string;
	code?: string;
	rule?: string;
	why?: string;
	part?: string;
	blocks: boolean;
	forDevelopers: boolean;
	total: number /* int */;
	paths: RiskPath[];
}
/**
 * RiskPath is one file (and line) a risk row names.
 */
export interface RiskPath {
	repo: string;
	path: string;
	line?: number /* int */;
}
/**
 * AreaRow is one area of the summary: a configured area's name or a repository's first directory,
 * with its size and change letters. Risky areas come first; Folded ones stand under "Less relevant".
 */
export interface AreaRow {
	part: string;
	repo: string;
	path: string;
	name?: string;
	files: number /* int */;
	added: number /* int */;
	removed: number /* int */;
	letters: AreaLetters;
	risky: boolean;
	folded: boolean;
}
/**
 * AreaLetters count an area's files by change: added, modified, deleted, renamed.
 */
export interface AreaLetters {
	A: number /* int */;
	M: number /* int */;
	D: number /* int */;
	R: number /* int */;
}
/**
 * FoldedCounts count the files the summary leaves under "Less relevant".
 */
export interface FoldedCounts {
	unlisted: number /* int */;
	generated: number /* int */;
}
/**
 * InvisibleRanges are the characters the review draws as chips instead of letting them vanish (S14
 * §11): C0 controls but the tab and the line feed, zero-width characters, bidi controls, the word
 * joiner and the invisible operators, variation selectors, the byte order mark and tag characters, as
 * hexadecimal code point ranges and single points in rising order. The line feed stays out because a
 * commit message is several lines and a chip per line break is noise; a diff line never holds one.
 * Named once: review's test and the browser (review/code/invisible.ts) parse this one string.
 */
export const InvisibleRanges = "0000-0008,000B-001F,200B-200F,202A-202E,2060-2064,2066-2069,FE00-FE0F,FEFF,E0000-E007F";
/**
 * FileList is a page of GET …/revisions/{n}/files.
 */
export interface FileList {
	files: FileRow[];
	nextCursor?: string;
}
/**
 * The change letter of a file.
 */
export const FileAdded = "A";
/**
 * The change letter of a file.
 */
export const FileModified = "M";
/**
 * The change letter of a file.
 */
export const FileDeleted = "D";
/**
 * The change letter of a file.
 */
export const FileRenamed = "R";
/**
 * The change letter of a file.
 */
export const FileType = "T";
/**
 * FileRow is one changed file of a revision. Class is core's path class; an Excluded file is named and
 * never read, so it has no diff.
 */
export interface FileRow {
	repo: string;
	path: string;
	oldPath?: string;
	status: string;
	oldMode?: string;
	newMode?: string;
	class: string;
	added: number /* int */;
	removed: number /* int */;
	binary: boolean;
	sizeOld?: number /* int64 */;
	sizeNew?: number /* int64 */;
	ownChangeId: string;
	excluded: boolean;
	risks: string[];
	since?: string;
}
/**
 * DiffList is POST …/revisions/{n}/diff's answer: one diff per file asked for, at most 1 MiB together.
 */
export interface DiffList {
	diffs: FileDiff[];
}
/**
 * FileDiff is one file's hunks against what the request named. Context is the lines of context around
 * each hunk (3, or 0 against an earlier revision); Truncated says the file passed 20 000 lines or 1 MiB.
 * EofOld and EofNew are git's "no newline at end of file" for the old and the new side
 * (core.FileHunks.EOF.Old and .New).
 */
export interface FileDiff {
	repo: string;
	path: string;
	hunks: Hunk[];
	context: number /* int */;
	binary: boolean;
	truncated: boolean;
	eofOld: boolean;
	eofNew: boolean;
}
/**
 * HunkFromMain marks a hunk against an earlier revision that main's own changes explain; it is drawn
 * grey and hidden until the reader asks for main's changes.
 */
export const HunkFromMain = "main";
/**
 * Hunk is one hunk of a diff.
 */
export interface Hunk {
	oldStart: number /* int */;
	oldLines: number /* int */;
	newStart: number /* int */;
	newLines: number /* int */;
	origin?: string;
	lines: HunkLine[];
}
/**
 * The kind of a hunk's line: context, removed, added.
 */
export const LineContext = " ";
/**
 * The kind of a hunk's line: context, removed, added.
 */
export const LineRemoved = "-";
/**
 * The kind of a hunk's line: context, removed, added.
 */
export const LineAdded = "+";
/**
 * HunkLine is one line of a hunk: its kind, its text, and how many characters past 2 000 the line
 * had that T does not show (the page says how much is cut).
 */
export interface HunkLine {
	k: string;
	t: string;
	cut?: number /* int */;
}
/**
 * FileText is POST …/revisions/{n}/text's answer: one side of a file, at most 200 KB.
 */
export interface FileText {
	text: string;
	truncated: boolean;
}
/**
 * The states of a revision's check run.
 */
export const ChecksNone = "none";
/**
 * The states of a revision's check run.
 */
export const ChecksQueued = "queued";
/**
 * The states of a revision's check run.
 */
export const ChecksRunning = "running";
/**
 * The states of a revision's check run.
 */
export const ChecksDone = "done";
/**
 * The states of a revision's check run.
 */
export const ChecksError = "error";
/**
 * The verdict of one check, head against base (S14 §7).
 */
export const VerdictNoWorse = "no_worse";
/**
 * The verdict of one check, head against base (S14 §7).
 */
export const VerdictWorse = "worse";
/**
 * The verdict of one check, head against base (S14 §7).
 */
export const VerdictRedBefore = "red_before";
/**
 * The verdict of one check, head against base (S14 §7).
 */
export const VerdictUnavailable = "unavailable";
/**
 * The verdict of one check, head against base (S14 §7).
 */
export const VerdictSkipped = "skipped";
/**
 * ChecksLine is a revision's checks in one line, as its row carries them: the run's state and, once it
 * is done, the worst verdict of its checks.
 */
export interface ChecksLine {
	state: string;
	verdict?: string;
}
/**
 * ChecksView is a revision's checks against main (S14 §7): one run per changed part, the revision's
 * verdict the worst of its parts'.
 */
export interface ChecksView {
	state: string;
	at?: number /* int64 */;
	parts: CheckPart[];
	rows: CheckRow[];
}
/**
 * The states of a part in a check run: its checks ran, or nothing of it changed.
 */
export const CheckPartChecked = "checked";
/**
 * The states of a part in a check run: its checks ran, or nothing of it changed.
 */
export const CheckPartUnchanged = "unchanged";
/**
 * CheckPart is one codebase part of a check run.
 */
export interface CheckPart {
	part: string;
	state: string;
}
/**
 * CheckRow is one check: its id (aichatapi's suite step), its part and kind, its status on main and in
 * the revision, and the verdict.
 */
export interface CheckRow {
	id: string;
	part: string;
	kind: string;
	base: CheckStatus;
	head: CheckStatus;
	verdict: string;
}
/**
 * CheckStatus is one side of a check: how it ended and, for diagnostics, how many it found.
 */
export interface CheckStatus {
	outcome: string;
	count?: number /* int */;
}
/**
 * The states of a landing (aichat_landing.state): live while pending or pushing, then landed, partly
 * landed or failed. gitflow keeps its landings in these words.
 */
export const LandingPending = "pending";
/**
 * The states of a landing (aichat_landing.state): live while pending or pushing, then landed, partly
 * landed or failed. gitflow keeps its landings in these words.
 */
export const LandingPushing = "pushing";
/**
 * The states of a landing (aichat_landing.state): live while pending or pushing, then landed, partly
 * landed or failed. gitflow keeps its landings in these words.
 */
export const LandingLanded = "landed";
/**
 * The states of a landing (aichat_landing.state): live while pending or pushing, then landed, partly
 * landed or failed. gitflow keeps its landings in these words.
 */
export const LandingPartial = "partial";
/**
 * The states of a landing (aichat_landing.state): live while pending or pushing, then landed, partly
 * landed or failed. gitflow keeps its landings in these words.
 */
export const LandingFailed = "failed";
/**
 * The states of one repository of a landing (aichat_landing_repo.state).
 */
export const PushPending = "pending";
/**
 * The states of one repository of a landing (aichat_landing_repo.state).
 */
export const PushPushing = "pushing";
/**
 * The states of one repository of a landing (aichat_landing_repo.state).
 */
export const PushPushed = "pushed";
/**
 * The states of one repository of a landing (aichat_landing_repo.state).
 */
export const PushRefused = "refused";
/**
 * The states of one repository of a landing (aichat_landing_repo.state).
 */
export const PushFailed = "failed";
/**
 * The states of one repository of a landing (aichat_landing_repo.state).
 */
export const PushSkipped = "skipped";
/**
 * LandingHead is `aichat.landing.changed` and the head of LandingView: each step of a publish, in ids
 * and words. Code is a failure class or a gate refusal, never git's own words.
 */
export interface LandingHead {
	chatId: number /* int64 */;
	landingId: number /* int64 */;
	n: number /* int64 */;
	attempt: number /* int64 */;
	state: string;
	repos: LandingRepoLine[];
	code?: string;
	by: number /* int64 */;
	at: number /* int64 */;
}
/**
 * LandingRepoLine is one repository of a landing, in landing order; Pushed is the commit main has from
 * this landing.
 */
export interface LandingRepoLine {
	repo: string;
	state: string;
	code?: string;
	pushed?: string;
}
/**
 * LandingView is GET …/landings/{id}: the belt under a lost aichat.landing.changed.
 */
export interface LandingView {
	head: LandingHead;
	repos: LandingRepoView[];
	override?: string;
	createdAt: number /* int64 */;
	finishedAt?: number /* int64 */;
}
/**
 * LandingRepoView is one repository of a landing with the commits main moved between.
 */
export interface LandingRepoView {
	repo: string;
	base: string;
	head: string;
	state: string;
	code?: string;
	pushAttempts: number /* int64 */;
	startedAt?: number /* int64 */;
	finishedAt?: number /* int64 */;
}

//////////
// source: revision.go

/**
 * RevisionCause is why a revision was made (aichatapi.RevisionCauses): claude, base, restore, parts.
 */
export type RevisionCause = string;
/**
 * RevisionHead is aichat.revision.new: a revision was written. It is thin, as every durable event
 * is: ids and words, each repository with the part that held it, its base and its canonical head.
 */
export interface RevisionHead {
	chatId: number /* int64 */;
	n: number /* int64 */;
	cause: RevisionCause;
	turnId?: number /* int64 */;
	reviewable: boolean;
	repos: RevisionHeadRepo[];
	at: number /* int64 */;
}
/**
 * RevisionHeadRepo is one repository of a new revision.
 */
export interface RevisionHeadRepo {
	repo: string;
	part: string;
	base: string;
	head: string;
}
/**
 * BaseUpdateRequest is POST …/base/update, "Update to latest".
 */
export interface BaseUpdateRequest {
	clientOpId: string;
}
/**
 * BaseUpdateAnswer is its answer: Current when the chat already stood on the latest main (200); the
 * move itself answers 202 with an empty body and arrives as aichat.chat.changed (a read-only chat's
 * pins) or aichat.revision.new (a chat with revisions).
 */
export interface BaseUpdateAnswer {
	current?: boolean;
}

//////////
// source: setup.go

/**
 * SetupView is GET /api/aichat/setup.
 */
export interface SetupView {
	parts: PartView[];
	defaults: SetupDefault;
	models: ModelRow[];
	/**
	 * Efforts are the effort levels the default model offers, as a chat's Claude Code last reported
	 * them; absent until one has, and then the form offers no effort of its own.
	 */
	efforts?: string[];
	owners: SetupOwners;
	timers: SetupTimers;
	machine: MachineLine;
	/**
	 * PublicAllowed is the admins' all-private switch off: a chat's owners may make any of its
	 * previews public, each from the chat's previews panel (a chat is never made with one public).
	 */
	publicAllowed: boolean;
	/**
	 * WorkflowAgentUnits is the configured mean usage of one workflow agent: a run of
	 * aichatapi.WorkflowWarnAgents agents or more says up front that it will spend about its agents
	 * times this on the team's plan. 0 draws no estimate.
	 */
	workflowAgentUnits: number /* int64 */;
	/**
	 * MyLogins are the caller's own Claude logins that are not disconnected, the active one first:
	 * whether they can send at all, and the one the new-chat form names as what the chat runs on.
	 * Absent while the caller has none.
	 */
	myLogins?: LoginLine[];
}
/**
 * PartView is one configured codebase part: its id, its name as the configuration writes it, its
 * repositories' ids in landing order, the default preview a chat holding it gets, and the words for
 * where its main goes live.
 */
export interface PartView {
	id: string;
	name: string;
	/**
	 * Repos are the part's repositories as people name them ([repos] name: taskGroups, teamBase), in
	 * landing order: words to read, never ids to send back.
	 */
	repos: string[];
	site: string;
	/**
	 * Platform is the name of the default preview a chat holding the part gets ("" for none): the
	 * system its repositories run.
	 */
	platform: api.PreviewName;
}
/**
 * SetupDefault is what a new chat gets for every setting the person leaves alone. Owners and
 * assignees are not here: their defaults are the team members group and the caller (SetupOwners).
 */
export interface SetupDefault {
	mode: api.ChatMode;
	model: string;
	effort: string;
}
/**
 * ModelRow is one model a chat may run, in the order the menu offers them. Resolved is the model id
 * the word runs on the worker machine's pinned Claude Code ("claude-opus-5-5" for "opus"), which the
 * web names it by ("Opus 5.5"); "" while the machine has not listed its models.
 */
export interface ModelRow {
	id: string;
	default: boolean;
	resolved?: string;
}
/**
 * SetupOwners are the two prominent owner choices: the team members group (the default) and the
 * caller's own personal group ("Only me"). Both exist for every person the module admits: core makes
 * the special groups with the first human account, and a personal group with every account.
 */
export interface SetupOwners {
	teamGroupId: number /* int64 */;
	myGroupId: number /* int64 */;
}
/**
 * SetupTimers are the clocks the page draws a countdown from, and the one it names in words:
 * DeactivateAfterMs is how long a chat may stay unused before it may be deactivated while the dev
 * worker is short of space (deactivate_after).
 */
export interface SetupTimers {
	cardWatchdogMs: number /* int64 */;
	stallNoticeMs: number /* int64 */;
	deactivateAfterMs: number /* int64 */;
}
/**
 * MachineLine is whether the worker machine takes AI chat work now: ready, starting, none (not
 * reachable) or disabled, since when this process has seen it so.
 */
export interface MachineLine {
	state: string;
	since?: number /* int64 */;
}
/**
 * CreateChatRequest is POST /api/aichat/chats: the first message and every setting of the new-chat
 * page in one body, so a chat is made whole in one transaction or not at all. A setting left out takes
 * SetupView's default.
 */
export interface CreateChatRequest {
	clientOpId: string;
	markdown: string;
	attachments?: core.AttachmentRef[];
	mode?: api.ChatMode;
	ownerGroupIds?: number /* int64 */[];
	assigneeIds?: number /* int64 */[];
	/**
	 * Title is a title the person typed; without one the chat is named from the first line of Markdown
	 * until Claude names it.
	 */
	title?: string;
	planFirst?: boolean;
	model?: string;
	effort?: string;
}

//////////
// source: states.go

/**
 * How a mode came to be (aichat_chat.mode_via): the creator's choice, an owner's switch, the answer to
 * Claude's request, or a switch dev refused and teamBase undid.
 */
export const ModeViaCreate = "create";
/**
 * How a mode came to be (aichat_chat.mode_via): the creator's choice, an owner's switch, the answer to
 * Claude's request, or a switch dev refused and teamBase undid.
 */
export const ModeViaOwner = "owner";
/**
 * How a mode came to be (aichat_chat.mode_via): the creator's choice, an owner's switch, the answer to
 * Claude's request, or a switch dev refused and teamBase undid.
 */
export const ModeViaCard = "card";
/**
 * How a mode came to be (aichat_chat.mode_via): the creator's choice, an owner's switch, the answer to
 * Claude's request, or a switch dev refused and teamBase undid.
 */
export const ModeViaRefused = "refused";
/**
 * Where the current title came from. Claude's title replaces only the first message's; a person's
 * title is never replaced by Claude's.
 */
export const TitleFromFirstMessage = "first_message";
/**
 * Where the current title came from. Claude's title replaces only the first message's; a person's
 * title is never replaced by Claude's.
 */
export const TitleFromClaude = "claude";
/**
 * Where the current title came from. Claude's title replaces only the first message's; a person's
 * title is never replaced by Claude's.
 */
export const TitleFromPerson = "person";
/**
 * The life axis. Closed and archived are both "archived" to the policy's N condition: nothing but
 * reopen and archive acts on them.
 */
export const LifeOpen = "open";
/**
 * The life axis. Closed and archived are both "archived" to the policy's N condition: nothing but
 * reopen and archive acts on them.
 */
export const LifeClosed = "closed";
/**
 * The life axis. Closed and archived are both "archived" to the policy's N condition: nothing but
 * reopen and archive acts on them.
 */
export const LifeArchived = "archived";
/**
 * Why a chat left open life (aichat_chat.life_reason): a person, or one of the timers and hooks that
 * act for nobody.
 */
export const LifeReasonPerson = "person";
/**
 * Why a chat left open life (aichat_chat.life_reason): a person, or one of the timers and hooks that
 * act for nobody.
 */
export const LifeReasonAutoLanded = "auto_landed";
/**
 * Why a chat left open life (aichat_chat.life_reason): a person, or one of the timers and hooks that
 * act for nobody.
 */
export const LifeReasonAutoUnchanged = "auto_unchanged";
/**
 * Why a chat left open life (aichat_chat.life_reason): a person, or one of the timers and hooks that
 * act for nobody.
 */
export const LifeReasonAuto = "auto";
/**
 * Why a chat left open life (aichat_chat.life_reason): a person, or one of the timers and hooks that
 * act for nobody.
 */
export const LifeReasonOwnerErased = "owner_erased";
/**
 * Why a chat left open life (aichat_chat.life_reason): a person, or one of the timers and hooks that
 * act for nobody.
 */
export const LifeReasonOwnersGone = "owners_gone";
/**
 * The run axis: what the chat is doing now, as teamBase sees it.
 */
export const RunIdle = "idle";
/**
 * The run axis: what the chat is doing now, as teamBase sees it.
 */
export const RunPreparing = "preparing";
/**
 * The run axis: what the chat is doing now, as teamBase sees it.
 */
export const RunWorking = "working";
/**
 * The run axis: what the chat is doing now, as teamBase sees it.
 */
export const RunWaiting = "waiting";
/**
 * The run axis: what the chat is doing now, as teamBase sees it.
 */
export const RunStopping = "stopping";
/**
 * The run axis: what the chat is doing now, as teamBase sees it.
 */
export const RunPaused = "paused";
/**
 * The change axis of a modifying chat: where its latest revision stands on the way to main. A
 * read-only chat has none and stores ChangeNone.
 */
export const ChangeNone = "none";
/**
 * The change axis of a modifying chat: where its latest revision stands on the way to main. A
 * read-only chat has none and stores ChangeNone.
 */
export const ChangeWip = "wip";
/**
 * The change axis of a modifying chat: where its latest revision stands on the way to main. A
 * read-only chat has none and stores ChangeNone.
 */
export const ChangeReview = "review";
/**
 * The change axis of a modifying chat: where its latest revision stands on the way to main. A
 * read-only chat has none and stores ChangeNone.
 */
export const ChangeReady = "ready";
/**
 * The change axis of a modifying chat: where its latest revision stands on the way to main. A
 * read-only chat has none and stores ChangeNone.
 */
export const ChangeLanding = "landing";
/**
 * The change axis of a modifying chat: where its latest revision stands on the way to main. A
 * read-only chat has none and stores ChangeNone.
 */
export const ChangeLanded = "landed";
/**
 * A person's hold on the queue: their own, a Stop that left the rest waiting, or the chat's close.
 */
export const HoldOwner = "owner";
/**
 * A person's hold on the queue: their own, a Stop that left the rest waiting, or the chat's close.
 */
export const HoldStop = "stop";
/**
 * A person's hold on the queue: their own, a Stop that left the rest waiting, or the chat's close.
 */
export const HoldClosed = "closed";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PausePlan = "plan";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseQuestion = "question";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseInterrupted = "interrupted";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseLimit = "limit";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseLogin = "login";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseTooLong = "too_long";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseCeiling = "ceiling";
/**
 * The system's pause: delivery stops until a person presses the pause's door.
 */
export const PauseDisk = "disk";
export const PauseModify = "modify";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineArchived = "archived";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineClosed = "closed";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlinePublishing = "publishing";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlinePartlyPublished = "partly_published";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineNeedsYou = "needs_you";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlinePaused = "paused";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineWorking = "working";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineReady = "ready";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineInReview = "in_review";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlinePublished = "published";
/**
 * The headline: the one word a list and the band show for a chat, first row of S01 §4.4 that holds.
 */
export const HeadlineIdle = "idle";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailPerson = LifeReasonPerson;
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailAuto = LifeReasonAuto;
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailOwnerErased = LifeReasonOwnerErased;
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailOwnersGone = LifeReasonOwnersGone;
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailAutoLanded = LifeReasonAutoLanded;
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailAutoUnchanged = LifeReasonAutoUnchanged;
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailPushing = "pushing";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailRepos = "repos";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailQuestion = "question";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailPlan = "plan";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailModifyRequest = "modify_request";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailLogin = "login";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailLimit = "limit";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailAway = "away";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailStopping = "stopping";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailSwitching = "switching";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailUpdating = "updating";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailInLine = "in_line";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailEditing = "editing";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailSettingUp = "setting_up";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailResuming = "resuming";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailCompacting = "compacting";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailStalled = "stalled";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailWorkflow = "workflow";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailBackground = "background";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailRevision = "revision";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailPublishFailed = "publish_failed";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailChecksFailed = "checks_failed";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailNeedsIntegrate = "needs_integration";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailBehindMain = "behind_main";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailChecksRunning = "checks_running";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailChecksQueued = "checks_queued";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailChecksNotStart = "checks_not_started";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailUncommitted = "uncommitted";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailHeld = "held";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailUnpublishedKept = "unpublished_kept";
/**
 * The run details of a chat's environment while a request waits on it. A setting-up, waking,
 * reactivating or resetting detail carries the step (aichatapi.EnvSteps) in DetailLine.State and
 * the start of the environment's state in DetailLine.At.
 */
export const DetailWaking = "waking";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailNotResponding = "not_responding";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailDeactivating = "deactivating";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailReactivating = "reactivating";
/**
 * The details a headline or a run carries: which of its reasons holds. A detail word is drawn beside
 * its headline word (aichat.detail.<word>), so one word may serve several headlines — the pauses are
 * both run details and the paused headline's detail.
 */
export const DetailResetting = "resetting";
/**
 * Why a head waits for its delivery in line (the in_line detail's Why): the machine's running budget
 * (or a worker of another release), the asker's own two running turns elsewhere, the machine's
 * network table, which is not loaded — the machine starts nothing until it is, so no place in line
 * means anything and the page says why — or the machine's disk, whose pool is below the floor a new
 * container needs, which only freeing space ends. Machine and network are the session host's own words
 * for its start line (aichatapi.LineWhys), spelt out here because the browser's generated constants
 * cannot name another package's; TestTheInLineWaitsAreTheHostsWords holds them equal. Disk is the
 * server's: the work session the machine answered with no room, which only the root helper's disk
 * floor causes.
 */
export const InLineMachine = "machine";
/**
 * Why a head waits for its delivery in line (the in_line detail's Why): the machine's running budget
 * (or a worker of another release), the asker's own two running turns elsewhere, the machine's
 * network table, which is not loaded — the machine starts nothing until it is, so no place in line
 * means anything and the page says why — or the machine's disk, whose pool is below the floor a new
 * container needs, which only freeing space ends. Machine and network are the session host's own words
 * for its start line (aichatapi.LineWhys), spelt out here because the browser's generated constants
 * cannot name another package's; TestTheInLineWaitsAreTheHostsWords holds them equal. Disk is the
 * server's: the work session the machine answered with no room, which only the root helper's disk
 * floor causes.
 */
export const InLineAsker = "asker";
/**
 * Why a head waits for its delivery in line (the in_line detail's Why): the machine's running budget
 * (or a worker of another release), the asker's own two running turns elsewhere, the machine's
 * network table, which is not loaded — the machine starts nothing until it is, so no place in line
 * means anything and the page says why — or the machine's disk, whose pool is below the floor a new
 * container needs, which only freeing space ends. Machine and network are the session host's own words
 * for its start line (aichatapi.LineWhys), spelt out here because the browser's generated constants
 * cannot name another package's; TestTheInLineWaitsAreTheHostsWords holds them equal. Disk is the
 * server's: the work session the machine answered with no room, which only the root helper's disk
 * floor causes.
 */
export const InLineNetwork = "network";
/**
 * Why a head waits for its delivery in line (the in_line detail's Why): the machine's running budget
 * (or a worker of another release), the asker's own two running turns elsewhere, the machine's
 * network table, which is not loaded — the machine starts nothing until it is, so no place in line
 * means anything and the page says why — or the machine's disk, whose pool is below the floor a new
 * container needs, which only freeing space ends. Machine and network are the session host's own words
 * for its start line (aichatapi.LineWhys), spelt out here because the browser's generated constants
 * cannot name another package's; TestTheInLineWaitsAreTheHostsWords holds them equal. Disk is the
 * server's: the work session the machine answered with no room, which only the root helper's disk
 * floor causes.
 */
export const InLineDisk = "disk";
/**
 * The tone a headline is drawn in. The browser maps a tone to its colour tokens; it never picks one.
 */
export const ToneMuted = "muted";
/**
 * The tone a headline is drawn in. The browser maps a tone to its colour tokens; it never picks one.
 */
export const ToneAccent = "accent";
/**
 * The tone a headline is drawn in. The browser maps a tone to its colour tokens; it never picks one.
 */
export const ToneDanger = "danger";
/**
 * The tone a headline is drawn in. The browser maps a tone to its colour tokens; it never picks one.
 */
export const ToneWarning = "warning";
/**
 * The tone a headline is drawn in. The browser maps a tone to its colour tokens; it never picks one.
 */
export const ToneSuccess = "success";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitQuestion = PauseQuestion;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitPlan = PausePlan;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitModifyRequest = "modify_request";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitLimit = PauseLimit;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitLogin = PauseLogin;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitInterrupted = PauseInterrupted;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitTooLong = PauseTooLong;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitCeiling = PauseCeiling;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitDisk = PauseDisk;
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitHeld = "held";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitPartlyPublished = "partly_published";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitFinished = "finished";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitReviewRequested = "review_requested";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitReady = "ready";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitChecksFailed = "checks_failed";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitNeedsIntegration = "needs_integration";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitAccessRequest = "access_request";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitStale = "stale";
/**
 * Why a chat waits for a person ("Waiting for you", S01 §4.5). The pauses a person resolves are
 * reasons too (question, plan, limit, …), under their pause word.
 */
export const WaitAssigned = "assigned";
/**
 * The tone of a wait: amber asks the reader to act, quiet only lists the chat, danger is a partial
 * publish nobody may leave behind.
 */
export const WaitToneAmber = "amber";
/**
 * The tone of a wait: amber asks the reader to act, quiet only lists the chat, danger is a partial
 * publish nobody may leave behind.
 */
export const WaitToneQuiet = "quiet";
/**
 * The tone of a wait: amber asks the reader to act, quiet only lists the chat, danger is a partial
 * publish nobody may leave behind.
 */
export const WaitToneDanger = "danger";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterOpen = "open";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterWaiting = "waiting";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterAssigned = "assigned";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterStarted = "started";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterLanded = "landed";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterClosed = "closed";
/**
 * The home list's filters (GET /api/aichat/chats?filter=…).
 */
export const FilterArchived = "archived";
/**
 * The admin's list filters (GET /api/admin/aichat/chats?filter=…): the lives, the chats whose
 * environment is deactivated, and every chat.
 */
export const AdminFilterOpen = FilterOpen;
/**
 * The admin's list filters (GET /api/admin/aichat/chats?filter=…): the lives, the chats whose
 * environment is deactivated, and every chat.
 */
export const AdminFilterClosed = FilterClosed;
/**
 * The admin's list filters (GET /api/admin/aichat/chats?filter=…): the lives, the chats whose
 * environment is deactivated, and every chat.
 */
export const AdminFilterArchived = FilterArchived;
/**
 * The admin's list filters (GET /api/admin/aichat/chats?filter=…): the lives, the chats whose
 * environment is deactivated, and every chat.
 */
export const AdminFilterDeactivated = "deactivated";
/**
 * The admin's list filters (GET /api/admin/aichat/chats?filter=…): the lives, the chats whose
 * environment is deactivated, and every chat.
 */
export const AdminFilterAll = "all";
/**
 * AdminFilterAgentsClosed is the one more filter the admin list takes, which its own page does not
 * offer: the chats closed to other AI chats, by when they were closed, newest first, read by the AI
 * chats part of Administration ▸ Open to AI chats. Every other chat stands at the default, open, so
 * that part counts them (AdminChatList.AgentsOpen) and lists only these (S-19-D19).
 */
export const AdminFilterAgentsClosed = "agents_closed";
/**
 * A chat's environment as teamBase records it (aichat_chat.env): none yet, present on the worker
 * machine, being deactivated, deactivated (its session and keep folder kept here, its container gone)
 * or being reactivated. Why it went is aichatapi.EnvCauses, read directly.
 */
export const EnvNone = "none";
/**
 * A chat's environment as teamBase records it (aichat_chat.env): none yet, present on the worker
 * machine, being deactivated, deactivated (its session and keep folder kept here, its container gone)
 * or being reactivated. Why it went is aichatapi.EnvCauses, read directly.
 */
export const EnvPresent = "present";
/**
 * A chat's environment as teamBase records it (aichat_chat.env): none yet, present on the worker
 * machine, being deactivated, deactivated (its session and keep folder kept here, its container gone)
 * or being reactivated. Why it went is aichatapi.EnvCauses, read directly.
 */
export const EnvDeactivating = "deactivating";
/**
 * A chat's environment as teamBase records it (aichat_chat.env): none yet, present on the worker
 * machine, being deactivated, deactivated (its session and keep folder kept here, its container gone)
 * or being reactivated. Why it went is aichatapi.EnvCauses, read directly.
 */
export const EnvDeactivated = "deactivated";
/**
 * A chat's environment as teamBase records it (aichat_chat.env): none yet, present on the worker
 * machine, being deactivated, deactivated (its session and keep folder kept here, its container gone)
 * or being reactivated. Why it went is aichatapi.EnvCauses, read directly.
 */
export const EnvReactivating = "reactivating";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordSettingUp = "setting_up";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordRunning = "running";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordAsleep = "asleep";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordWaking = "waking";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordInLine = "in_line";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordNotResponding = "not_responding";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordDeactivating = "deactivating";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordDeactivated = "deactivated";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordReactivating = "reactivating";
/**
 * The word people see for a chat's environment (aichat.env.state.<word>), derived on teamBase from
 * the recorded env and its cause and the container's state in the host picture; the worker never
 * sends one.
 */
export const EnvWordResetting = "resetting";
/**
 * Why a preview may not run now (aichat_preview.off_cause): it is a running system and the chat
 * cannot change code, or the chat is closed or archived — aichatapi.PreviewAllowed's words, which a
 * test holds equal.
 */
export const OffCauseMode = "mode";
/**
 * Why a preview may not run now (aichat_preview.off_cause): it is a running system and the chat
 * cannot change code, or the chat is closed or archived — aichatapi.PreviewAllowed's words, which a
 * test holds equal.
 */
export const OffCauseLife = "life";
/**
 * Who started a preview last (aichat_preview.start_by): an owner's press, or a visit to its preview.
 */
export const StartByOwner = "owner";
/**
 * Who started a preview last (aichat_preview.start_by): an owner's press, or a visit to its preview.
 */
export const StartByVisit = "visit";
/**
 * Why a chat has no preview of a name (NoPreviewDetail.Reason): it is a running system and the chat
 * cannot change code (read), or the chat's previews file does not declare it (config).
 */
export const NoPreviewRead = "read";
/**
 * Why a chat has no preview of a name (NoPreviewDetail.Reason): it is a running system and the chat
 * cannot change code (read), or the chat's previews file does not declare it (config).
 */
export const NoPreviewConfig = "config";
/**
 * PreviewOff is a preview as a person sees it when it may not run now (OffCauses say why), beside
 * the machine's own states of a preview.
 */
export const PreviewOff = "off";

//////////
// source: types.go
/*
Package wire is the AI chats module's half of the browser's vocabulary: every event type string the
module sends, and one struct per reply and event. It is a tygo input (tygo.yaml →
web/src/modules/aichat/wire/aichat.gen.ts), so it holds no behaviour and no store row; the
discriminated event union the browser applies is written by hand beside the generated file.

What crosses between the two machines is not here but in aichatapi, which this package imports for
the words both share (an item's kind, a chat's mode): a browser type that names a kind names the
same word the worker machine wrote.

The subpackage rule of architecture.md D3 holds: wire imports core's wire package and aichatapi,
and nothing of the module root. From core itself it takes core.Secret alone, the type of the one
secret a body carries (a member's Claude token, login.go), so that the token cannot be printed or
logged from the moment it is decoded.
*/

/**
 * TypeAichatChatChanged carries a chat's whole ChatRow whenever any of its fields moves, and at
 * every turn's end, so a reader who was away learns the chat's item rev.
 */
export const TypeAichatChatChanged = "aichat.chat.changed";
/**
 * TypeAichatChatGone tells one person that an act took their ownership of a chat away.
 */
export const TypeAichatChatGone = "aichat.chat.gone";
/**
 * TypeAichatItemNew and TypeAichatItemChanged carry an evented item's head: a prompt, a card, an
 * answer, a shared act, a turn's end — or any item written while the chat is not working.
 */
export const TypeAichatItemNew = "aichat.item.new";
/**
 * The durable events (S03 §3). Each is kept in the change log and replayed to a reader who was away,
 * so each is thin: ids, words from a declared set, counts and revs — never a title, a prompt, an
 * answer, a reason Claude gave or a path. The words themselves reach a reader only through a read
 * that checks who is asking.
 */
export const TypeAichatItemChanged = "aichat.item.changed";
/**
 * TypeAichatRevisionNew and TypeAichatLandingChanged follow a modifying chat's work: a new
 * revision of it, and each step of a publish.
 */
export const TypeAichatRevisionNew = "aichat.revision.new";
/**
 * The durable events (S03 §3). Each is kept in the change log and replayed to a reader who was away,
 * so each is thin: ids, words from a declared set, counts and revs — never a title, a prompt, an
 * answer, a reason Claude gave or a path. The words themselves reach a reader only through a read
 * that checks who is asking.
 */
export const TypeAichatLandingChanged = "aichat.landing.changed";
/**
 * TypeAichatReaderState is one person's read cursor of a chat, to that person only.
 */
export const TypeAichatReaderState = "aichat.reader.state";
/**
 * TypeAichatLoginChanged and TypeAichatMachineChanged go to every team member: a Claude login's
 * state and usage, and the worker machine's state word.
 */
export const TypeAichatLoginChanged = "aichat.login.changed";
/**
 * The durable events (S03 §3). Each is kept in the change log and replayed to a reader who was away,
 * so each is thin: ids, words from a declared set, counts and revs — never a title, a prompt, an
 * answer, a reason Claude gave or a path. The words themselves reach a reader only through a read
 * that checks who is asking.
 */
export const TypeAichatMachineChanged = "aichat.machine.changed";
/**
 * TypeAichatPreviewChanged and TypeAichatAccessChanged follow a modifying chat's preview and the
 * access its visitors asked for (R1b).
 */
export const TypeAichatPreviewChanged = "aichat.preview.changed";
/**
 * The durable events (S03 §3). Each is kept in the change log and replayed to a reader who was away,
 * so each is thin: ids, words from a declared set, counts and revs — never a title, a prompt, an
 * answer, a reason Claude gave or a path. The words themselves reach a reader only through a read
 * that checks who is asking.
 */
export const TypeAichatAccessChanged = "aichat.access.changed";
/**
 * The ephemeral frames (S03 §4). Every one is focused-only: it reaches only the connections that have
 * the chat on screen, is never written to the change log and never logged, and carries the newest
 * picture of something — the model's text while it streams, a workflow's agents, one agent's tail.
 */
export const TypeAichatLive = "aichat.live";
/**
 * The ephemeral frames (S03 §4). Every one is focused-only: it reaches only the connections that have
 * the chat on screen, is never written to the change log and never logged, and carries the newest
 * picture of something — the model's text while it streams, a workflow's agents, one agent's tail.
 */
export const TypeAichatWorkflow = "aichat.workflow";
/**
 * The ephemeral frames (S03 §4). Every one is focused-only: it reaches only the connections that have
 * the chat on screen, is never written to the change log and never logged, and carries the newest
 * picture of something — the model's text while it streams, a workflow's agents, one agent's tail.
 */
export const TypeAichatAgent = "aichat.agent";
/**
 * The ephemeral frames (S03 §4). Every one is focused-only: it reaches only the connections that have
 * the chat on screen, is never written to the change log and never logged, and carries the newest
 * picture of something — the model's text while it streams, a workflow's agents, one agent's tail.
 */
export const TypeAichatTyping = "aichat.typing";
/**
 * The ephemeral frames (S03 §4). Every one is focused-only: it reaches only the connections that have
 * the chat on screen, is never written to the change log and never logged, and carries the newest
 * picture of something — the model's text while it streams, a workflow's agents, one agent's tail.
 */
export const TypeAichatViewers = "aichat.viewers";
/**
 * TypeAichatTerminalOutput is a piece of the chat's terminal screen. Unlike the others it is
 * uncoalesced: every frame counts and arrives in order, none replaces another, and under pressure
 * one is dropped whole and the page asks for a keyframe.
 */
export const TypeAichatTerminalOutput = "aichat.terminal.output";
/**
 * The socket requests of the chat's terminal (S02 §5.2): a page that shows the terminal attaches to it
 * (who watches, at what size, and whether it needs a keyframe), and an owner's keys go down as input.
 * Their answers are empty; what they cause arrives as TypeAichatTerminalOutput and TypeAichatViewers.
 */
export const TypeAichatTerminalAttach = "aichat.terminal.attach";
/**
 * The socket requests of the chat's terminal (S02 §5.2): a page that shows the terminal attaches to it
 * (who watches, at what size, and whether it needs a keyframe), and an owner's keys go down as input.
 * Their answers are empty; what they cause arrives as TypeAichatTerminalOutput and TypeAichatViewers.
 */
export const TypeAichatTerminalInput = "aichat.terminal.input";
